// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].use[1]!./fonts.css";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27%3e%3cpath fill=%27none%27 stroke=%27%23c4c4c4%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%272%27 d=%27m2 5 6 6 6-6%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27%3e%3cpath fill=%27none%27 stroke=%27%23ffffff%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%272%27 d=%27m2 5 6 6 6-6%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27%3E%3Cpath fill=%27%23000000%27 d=%27M8,10.7l5.3,5.3c0.1,0.1,0.2,0.1,0.3,0l2.4-2.4c0.1-0.1,0.1-0.2,0-0.3L10.7,8l5.2-5.2c0.1-0.1,0.1-0.2,0-0.3l-2.4-2.4 c-0.1-0.1-0.2-0.1-0.3,0L8,5.3L2.7,0.1C2.7,0,2.5,0,2.4,0.1L0.1,2.4C0,2.5,0,2.7,0.1,2.7L5.3,8l-5.3,5.3c-0.1,0.1-0.1,0.2,0,0.3 l2.4,2.4c0.1,0.1,0.2,0.1,0.3,0L8,10.7z%27/%3E%3C/svg%3E%0A", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%27-4 -4 8 8%27%3e%3ccircle r=%273%27 fill=%27%23A570FA%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%27-4 -4 8 8%27%3e%3ccircle r=%273%27 fill=%27%23fff%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Inter:wght@100;200;300;400;500;600;700;800;900&display=swap);"]);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* CSS Document */

/* see https://getbootstrap.com/docs/5.3/customize/color-modes/#javascript for color switch*/

/***************** fonts ******************/
/* @import url('https://fonts.googleapis.com/css2?family=Rubik:ital,wght@0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap'); */

:root body.theme-1 {
	--bg-primary: #e6e6e6; /*bg-primary-1dp*/
	--bg-primary-rgb: 230, 230, 230; /*bg-primary-1dp*/
	--bg-primary-1dp: #F5F5F5;
	--bg-primary-2dp: #F5F5F5;
	--bg-primary-5dp: #F5F5F5;
	--bg-primary-8dp: #ECECEC;
	--bg-primary-12dp: #d9d8d8;
	--bg-primary-24dp: #dadada;
	--bg-primary-30dp: #c4c4c4;
	
	--color-primary-8dp: #E1E1E1;
	--color-primary-24dp: #dadada; /*bg-primary-1dp*/
	--color-primary-30dp: #c4c4c4;
	
	--brand-rgb: 0, 128, 128;
	--brand-hue: 180;
	--brand-saturation: 100%;
	--brand-lightness: 25%;

	--brand: rgb(var(--brand-rgb)); 
	--client: rgb(var(--client-rgb));
	--client-rgb: 0, 71, 185;

	--bs-danger: #FA7070; 
	--bs-info: #19cfcf;
	--project: var(--bs-secondary);
	--project-rgb: var(--bs-secondary-rgb);
	--bs-secondary-rgb: 116, 77, 178;
	--bs-secondary: rgb(var(--bs-secondary-rgb)); 
	--bs-secondary-hue: 263;
	--bs-secondary-saturation: 93%;
	--bs-secondary-lightness: 71%;
	--bs-success: #84e445;
	--task: rgb(var(--task-rgb));
	--task-rgb: 155, 72, 154;
	--bs-warning: #ffc107;
	--ws: rgb(var(--ws-rgb));
	--ws-rgb: 234, 88, 139;

	--color-0: #000000;
	--color-1: #6c757d;
	--color-2: #9fbe25;
	--color-3: #ffc107;;
	--color-4: #fd7e14;
	--color-5: #dc3545;
	--color-6: #d63384;
	--color-7: #6f42c1;
	--color-8: #6610f2;
	--color-9: #0d6efd;
	--color-10: #0dcaf0;
	--color-11: #198754;
	--color-12: #20c997;
	
	--scrollbar-width: 10px;
	--shadow-rgb: 200 200 200;

	--text-primary-high-emp: rgba(var(--bs-black-rgb), .87);
	--text-primary-medium-emp: rgba(var(--bs-black-rgb), .60);
	--text-primary-low-emp: rgba(var(--bs-black-rgb), .38);
}

:root body.theme-2 {
	--bg-primary: #121212; /*bg-primary-1dp*/
	--bg-primary-rgb: 18, 18, 18; /*bg-primary-1dp*/
	--bg-primary-1dp: linear-gradient(rgba(var(--bs-white-rgb), 5%), rgba(var(--bs-white-rgb), 5%)), linear-gradient(var(--bg-primary), var(--bg-primary));
	--bg-primary-2dp: linear-gradient(rgba(var(--bs-white-rgb), 7%), rgba(var(--bs-white-rgb), 7%)), linear-gradient(var(--bg-primary), var(--bg-primary));
	--bg-primary-5dp: linear-gradient(rgba(var(--bs-white-rgb), 10%), rgba(var(--bs-white-rgb), 10%)), linear-gradient(var(--bg-primary), var(--bg-primary));
	--bg-primary-8dp: linear-gradient(rgba(var(--bs-white-rgb), 12%), rgba(var(--bs-white-rgb), 12%)), linear-gradient(var(--bg-primary), var(--bg-primary));
	--bg-primary-12dp: linear-gradient(rgba(var(--bs-white-rgb), 14%), rgba(var(--bs-white-rgb), 14%)), linear-gradient(var(--bg-primary), var(--bg-primary));
	--bg-primary-24dp: linear-gradient(rgba(var(--bs-white-rgb), 16%), rgba(var(--bs-white-rgb), 16%)), linear-gradient(var(--bg-primary), var(--bg-primary));
	--bg-primary-30dp: linear-gradient(rgba(var(--bs-white-rgb), 24%), rgba(var(--bs-white-rgb), 24%)), linear-gradient(var(--bg-primary), var(--bg-primary));
	--color-primary-5dp: #2A2A2A;	
	--color-primary-8dp: #2E2E2E;	
	--color-primary-24dp: #383838; /*bg-primary-1dp*/
	--color-primary-30dp: #4B4B4B;

	--brand-rgb: 0, 128, 128;
	--brand-hue: 180;
	--brand-saturation: 100%;
	--brand-lightness: 25%;

	--brand: rgb(var(--brand-rgb)); 
	--client: rgb(var(--client-rgb));
	--client-rgb: 112, 151, 250;

	--bs-danger: #FA7070; 
	--bs-info: #70FAFA;
	--project: var(--bs-secondary);
	--project-rgb: var(--bs-secondary-rgb);
	--bs-secondary-rgb: 165, 112, 250;
	--bs-secondary: rgb(var(--bs-secondary-rgb)); 
	--bs-secondary-hue: 263;
	--bs-secondary-saturation: 93%;
	--bs-secondary-lightness: 71%;
	--bs-success: #A7FA70;
	--task: rgb(var(--task-rgb));
	--task-rgb: 250, 112, 243;
	--bs-warning: #EEFA70;
	--ws: rgb(var(--ws-rgb));
	--ws-rgb: 250, 165, 112;

	--color-0: #ffffff;
	--color-1: #6c757d;
	--color-2: #9fbe25;
	--color-3: #ffc107;;
	--color-4: #fd7e14;
	--color-5: #dc3545;
	--color-6: #d63384;
	--color-7: #6f42c1;
	--color-8: #6610f2;
	--color-9: #0d6efd;
	--color-10: #0dcaf0;
	--color-11: #198754;
	--color-12: #20c997;
	
	--shadow-rgb: 0, 0, 0;
	--scrollbar-width: 10px;

	--text-primary-high-emp: rgba(var(--bs-white-rgb), .87);
	--text-primary-medium-emp: rgba(var(--bs-white-rgb), .60);
	--text-primary-low-emp: rgba(var(--bs-white-rgb), .38);
}

/* width */
::-webkit-scrollbar {
	width: var(--scrollbar-width);
}

/* Track */
::-webkit-scrollbar-track {
	background: var(--bg-primary-12dp);
}

/* Handle */
::-webkit-scrollbar-thumb {
	background: var(--brand);
	border-radius: var(--scrollbar-width);
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
	background: hsl(var(--brand-hue), var(--brand-saturation), calc(var(--brand-lightness) - 10%));
}

 /* Chrome, Firefox, Opera, Safari 10.1+ */
/* ::placeholder {
	color: var(--text-primary-low-emp) !important;
	opacity: 1;
} */

 /* WebKit, Blink, Edge */
/* ::-webkit-input-placeholder {
 	color: var(--text-primary-low-emp) !important;
} */

 /* Mozilla Firefox 4 to 18 */
/* :-moz-placeholder {
 	color: var(--text-primary-low-emp) !important;
 	opacity: 1;
} */

 /* Mozilla Firefox 19+ */
/* ::-moz-placeholder {
 	color: var(--text-primary-low-emp) !important;
 	opacity: 1;
} */

 /* Internet Explorer 10-11 */
/* :-ms-input-placeholder {
 	color: var(--text-primary-low-emp) !important;
} */

 /* Microsoft Edge */
/* ::-ms-input-placeholder {
 	color: var(--text-primary-low-emp) !important;
} */

 /* Most modern browsers support this now. */
/* ::placeholder {
 	color: var(--text-primary-low-emp) !important;
} */

/******************** site *******************/
/* TODO:metti tutto insieme */

a, a:hover {
	color: #e2e2e2;
	outline: none;
}

a:hover {
	color: #3c763d;
}

body {
	background: var(--bg-primary);
	color: var(--text-primary-high-emp);
	/* color: #212529; */
	cursor: default;
	/* based onWorkSession */
}

body.theme-1 input {
	color-scheme: light;
}

body.theme-1 .form-select {
	background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}

body.theme-2 input {
	color-scheme: dark;
}

body.theme-2 .form-select {
	background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}

body.isRunningWorkSession {
	padding-bottom: calc(1rem + .5rem + 1rem + .5rem + ((1.5rem) * 3) + 1rem);
}

body[data-page-id="signView"] {
	padding-bottom:0;
}

body, 
html {
	font-family: "Inter", sans-serif;
	min-height: 100%;
}

button.icon-.collapsed::before {
	transform: rotate(0deg);
}

button.icon-:before {
	content: "\\E905";
	display: block;
	transform: rotate(90deg);
	transition: .4s all;
}

h1, h2, h3, h4, h5, h6,
label,
p, 
.prevent-select {
	-webkit-user-select: none; /* Safari */
	-ms-user-select: none; /* IE 10 and IE 11 */
	user-select: none; /* Standard syntax */
}

input {
	border: none;
	border-radius: 0.2rem;
	color: var(--text-primary-high-emp);
	padding: 0.1rem 0.2rem
}

input[type=number] {
	text-align: right;
}

input[type=range] {
	-webkit-appearance: none;
	margin: 0 0;
	width: 100%;
}

input[type=range]:focus {
	outline: none;
}

input[type=range]::-webkit-slider-runnable-track {
	width: 100%;
	height: 1rem;
	cursor: pointer;
	box-shadow: 0px 0px 0px #000000, 0px 0px 0px #000000;
	background: var(--bg-primary-12dp);
	border-radius: 25px;
	border: 0px solid #000000;
}

input[type=range]::-webkit-slider-thumb {
	box-shadow: 0px 0px 0px #000000, 0px 0px 0px #000000;
	border: 0px solid #000000;
	height: 1.5rem;
	width: 1.5rem;
	border-radius: 50%;
	background: var(--brand);;
	cursor: pointer;
	-webkit-appearance: none;
	margin-top: -0.25rem;
}

input[type=range]:focus::-webkit-slider-runnable-track {
	background: var(--color-primary-24dp);
}

input[type=range]::-moz-range-track {
	width: 100%;
	height: 1rem;
	cursor: pointer;
	animate: 0.2s;
	box-shadow: 0px 0px 0px #000000, 0px 0px 0px #000000;
	background: var(--color-primary-24dp);
	border-radius: 25px;
	border: 0px solid #000000;
}

input[type=range]::-moz-range-thumb {
	box-shadow: 0px 0px 0px #000000, 0px 0px 0px #000000;
	border: 0px solid #000000;
	height: 1.5rem;
	width: 1.5rem;
	border-radius: 7px;
	background: #65001c;
	cursor: pointer;
}

input[type=range]::-ms-track {
	width: 100%;
	height: 1rem;
	cursor: pointer;
	animate: 0.2s;
	background: transparent;
	border-color: transparent;
	border-width: 39px 0;
	color: transparent;
}

input[type=range]::-ms-fill-lower {
	background: #000000;
	border: 0px solid #000000;
	border-radius: 50px;
	box-shadow: 0px 0px 0px #000000, 0px 0px 0px #000000;
}

input[type=range]::-ms-fill-upper {
	background: #000000;
	border: 0px solid #000000;
	border-radius: 50%;
	box-shadow: 0px 0px 0px #000000, 0px 0px 0px #0d0d0d;
}

input[type=range]::-ms-thumb {
	box-shadow: 0px 0px 0px #000000, 0px 0px 0px #000000;
	border: 0px solid #000000;
	height: 1.5rem;
	width: 1.5rem;
	border-radius: 50%;
	background: #000000;
	cursor: pointer;
}

input[type=range]:focus::-ms-fill-lower {
	background: #000000;
}

input[type=range]:focus::-ms-fill-upper {
	background: #000000;
}

input[type=search]::-webkit-search-cancel-button {
	background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
}

input[type=search]::-webkit-search-cancel-button {
	/* background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3e%3cpath fill='none' stroke='%23ffffff' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='m2 5 6 6 6-6'/%3e%3c/svg%3e"); */
	height: .5rem;
	right: 0;
	width: .5rem;
	-webkit-appearance: none;
}

input[type=search].form-control {
	padding-right: 0;
}

input[type=search]::placeholder {
 	color: var(--text-primary-low-emp);
}

table th {
	color: var(--text-primary-high-emp);
}

table td {
	align-items: center;
	color: var(--text-primary-medium-emp);
	vertical-align: middle;
}

table td span.badge {
	display: table-cell;
}

table.table-striped>tbody>tr:nth-of-type(even)>* {
	background-color: var(--color-primary-5dp);
}

table.table-striped>tbody>tr:nth-of-type(even)>*, 
table.table-striped>tbody>tr:nth-of-type(odd)>* {
	--bs-table-accent-bg: transparent;
	color: var(--text-primary-high-emp);
}

/* table.table-striped>tbody>tr:nth-of-type(odd)>* {
} */

table#tableStats td {
	vertical-align: top;
}

table#tableStats th {
	padding: 0 .25rem;
}

table.table>:not(caption)>*>* {
	padding: 0;
	background-color: transparent;
	border: none;
	box-shadow: none;
}

.activity-color-display {
	border-radius: 50%;
	display: inline-block;
	height: 2em;
	width: 2em;
}

.activity-color-display.color-0, 
.bg-color-0, 
.color-0::before, 
.bg-color-0::before, 
.badge.color-0 {
	background-color: var(--color-0);
}

.border-color-0 {
	border-color: var(--color-0) !important;
}

.activity-color-display.color-1, 
.bg-color-1, 
.color-1::before, 
.bg-color-1::before, 
.badge.color-1 {
	background-color: var(--color-1) !important; /* Dave: serve l'important se no vince il bianco */
}

.border-color-1 {
	border-color: var(--color-1) !important;
}

.activity-color-display.color-2, 
.bg-color-2, 
.color-2::before, 
.bg-color-2::before, 
.badge.color-2 {
	background-color: var(--color-2) !important; /* Dave: serve l'important se no vince il bianco */
}

.border-color-2 {
	border-color: var(--color-2) !important;
}

.activity-color-display.color-3, 
.bg-color-3, 
.color-3::before, 
.bg-color-3::before, 
.badge.color-3 {
	background-color: var(--color-3) !important; /* Dave: serve l'important se no vince il bianco */
}

.border-color-3 {
	border-color: var(--color-3) !important;
}

.activity-color-display.color-4, 
.bg-color-4, 
.color-4::before, 
.bg-color-4::before, 
.badge.color-4 {
	background-color: var(--color-4) !important; /* Dave: serve l'important se no vince il bianco */
}

.border-color-4 {
	border-color: var(--color-4) !important;
}

.activity-color-display.color-5, 
.bg-color-5, 
.color-5::before, 
.bg-color-5::before, 
.badge.color-5 {
	background-color: var(--color-5) !important; /* Dave: serve l'important se no vince il bianco */
}

.border-color-5 {
	border-color: var(--color-5) !important;
}

.activity-color-display.color-6, 
.bg-color-6, 
.color-6::before, 
.bg-color-6::before, 
.badge.color-6 {
	background-color: var(--color-6) !important; /* Dave: serve l'important se no vince il bianco */
}

.border-color-6 {
	border-color: var(--color-6) !important;
}

.activity-color-display.color-7, 
.bg-color-7, 
.color-7::before, 
.bg-color-7::before, 
.badge.color-7 {
	background-color: var(--color-7) !important; /* Dave: serve l'important se no vince il bianco */
}

.border-color-7 {
	border-color: var(--color-7) !important;
}

.activity-color-display.color-8, 
.bg-color-8, 
.color-8::before, 
.bg-color-8::before, 
.badge.color-8 {
	background-color: var(--color-8) !important; /* Dave: serve l'important se no vince il bianco */
}

.border-color-8 {
	border-color: var(--color-8) !important;
}

.activity-color-display.color-9, 
.bg-color-9, 
.color-9::before, 
.bg-color-9::before, 
.badge.color-9 {
	background-color: var(--color-9) !important; /* Dave: serve l'important se no vince il bianco */
}

.border-color-9 {
	border-color: var(--color-9) !important;
}

.activity-color-display.color-10, 
.bg-color-10, 
.color-10::before, 
.bg-color-110::before, 
.badge.color-10 {
	background-color: var(--color-10) !important; /* Dave: serve l'important se no vince il bianco */
}

.border-color-10 {
	border-color: var(--color-10) !important;

}

.activity-color-display.color-11, 
.bg-color-11, 
.color-11::before, 
.bg-color-111::before, 
.badge.color-11 {
	background-color: var(--color-11) !important; /* Dave: serve l'important se no vince il bianco */
}

.border-color-11 {
	border-color: var(--color-11) !important;
}

.activity-color-display.color-12, 
.bg-color-12, 
.color-12::before, 
.bg-color-112::before, 
.badge.color-12 {
	background-color: var(--color-12) !important; /* Dave: serve l'important se no vince il bianco */
}

.border-color-12 {
	border-color: var(--color-12) !important;
}


.badge-pill {
	margin-right: .5em;
}

.bg-body {
	background-color: var(--bg-primary);
}

.bg-danger {
	background-color: var(--bs-danger) !important;
}

/* .bg-levels {
	background-color: rgba(var(--bs-white-rgb), .05);
} */

.bg-primary {
	background-color: var(--brand) !important;
}

.bg-secondary {
	background-color: var(--bs-secondary) !important;
}

.bg-warning {
	background-color: var(--bs-warning) !important;
}

.bg-client {
	background-color: var(--client);
}

.bg-project {
	background-color: var(--project) ;
}

.bg-task {
	background-color: var(--task) ;
}

.bg-ws {
	background-color: var(--ws) ;
}

.bg-0dp {
	background: var(--bg-primary);
}

.bg-1dp {
	background: var(--bg-primary-1dp);
}

.bg-2dp {
	background: var(--bg-primary-2dp);
}

.bg-5dp {
	background: var(--bg-primary-5dp);
}

.bg-8dp {
	background: var(--bg-primary-8dp);
}

.bg-12dp {
	background: var(--bg-primary-12dp);
}

.bg-24dp {
	background: var(--bg-primary-24dp);
}

.border-24dp {
	border-color: var(--color-primary-24dp) !important;
	opacity: 1;
}

.border-start-4 {
	border-left-width: 4px !important; 
}

.btn {
	align-items: center;
	border: none;
	/* display: flex; */ /* Dave: occhio, il display flex rompe tutti i bottoni, chiedere a Dave*/
}

/* change in small */
.btn, 
.dropdown-menu-container, 
.swap-background-checkbox > input[type=checkbox].form-check-input ~ label, 
.swap-background-checkbox > input[type=radio].form-check-input ~ label, 
.form-control, 
.form-control-plaintext, 
.form-select, 
/* .input-group input, */
.input-group-text {
	border: none;
	border-radius: 0.375rem;
	line-height: 1.5em;
	padding: .25rem .5rem;
} 

.btn:hover.dropdown-toggle {
	border: 2px solid var(--color-primary-30dp);
}

.btn.active {
	color: var(--text-primary-high-emp);
 	background: var(--bg-primary-24dp);
}

.btn.disabled, 
.disabled {
	opacity: .3;
	pointer-events: none;
}

.btn-dark {
 	--bs-btn-color: #fff;
 	--bs-btn-bg: var(--color-primary-24dp);
 	--bs-btn-border-color: var(--color-primary-24dp);
 	--bs-btn-hover-color: #fff;
 	--bs-btn-hover-bg: #424649;
 	--bs-btn-hover-border-color: #373b3e;
 	--bs-btn-focus-shadow-rgb: 66,70,73;
 	--bs-btn-active-color: #fff;
 	--bs-btn-active-bg: #4d5154;
 	--bs-btn-active-border-color: #373b3e;
 	--bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
 	--bs-btn-disabled-color: #fff;
 	--bs-btn-disabled-bg: #212529;
 	--bs-btn-disabled-border-color: #212529;
}

.btn-circle {
	aspect-ratio: 1;
	justify-content: center;
	line-height: 0;
	width: 2.5em;
}

.btn-circle-sm {
	font-size: 0.7rem;
	height: 1.5rem;
 	padding: unset;
	width: 1.5rem;
}

.btn-light {
	background: none;
}

.btn-light,
.btn-light:hover,
.btn-check+.btn:hover {
	color: var(--text-primary-medium-emp); 
}

.btn-light:active, 
.btn-check:checked+.btn {
	color: var(--text-primary-high-emp); 
}

.btn-light:active, 
.btn-light:hover, 
.btn-check+.btn:hover, 
.btn-check:checked+.btn {
	background: var(--bg-primary-24dp);
}

.btn-link {
	--bs-btn-color: hsl(var(--brand-hue), var(--brand-saturation), calc(var(--brand-lightness) + 5%));
	--bs-btn-hover-color: var(--brand);
	--bs-btn-active-color: var(--brand);
}


#signView .btn-link {
	--bs-btn-color: var(--bs-secondary);
	--bs-btn-hover-color: hsl(var(--bs-secondary-hue), var(--bs-secondary-saturation), calc(var(--bs-secondary-lightness) + 5%));
	--bs-btn-active-color: hsl(var(--bs-secondary-hue), var(--bs-secondary-saturation), calc(var(--bs-secondary-lightness) + 5%));
}

.btn-primary {
 	--bs-btn-color: #fff;
 	--bs-btn-bg: var(--brand);
 	--bs-btn-border-color: var(--brand);
 	--bs-btn-hover-color: #fff;
 	--bs-btn-hover-bg: hsl(var(--brand-hue), var(--brand-saturation), calc(var(--brand-lightness) + 5%)); 
 	--bs-btn-hover-border-color: hsl(var(--brand-hue), var(--brand-saturation), calc(var(--brand-lightness) + 5%)); 
 	--bs-btn-focus-shadow-rgb: 49,132,253;
 	--bs-btn-active-color: #fff;
 	--bs-btn-active-bg: hsl(var(--brand-hue), var(--brand-saturation), calc(var(--brand-lightness) + 10%));
 	--bs-btn-active-border-color: hsl(var(--brand-hue), var(--brand-saturation), calc(var(--brand-lightness) + 10%));
 	--bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
 	--bs-btn-disabled-color: #fff;
 	--bs-btn-disabled-bg: hsl(var(--brand-hue), var(--brand-saturation), calc(var(--brand-lightness) - 5%));
 	--bs-btn-disabled-border-color: hsl(var(--brand-hue), var(--brand-saturation), calc(var(--brand-lightness) - 5%));
}

/* .btn-primary, 
.btn-primary.disabled { 
	background-color: var(--brand);
} */

.btn-primary.active {
	background: var(--brand);
}

.btn-pwsm {
	background: #666666;
	border: 1px solid #000000;
	color: #eeeeee;
	outline: none;
}

.btn-pwsm:focus, 
.btn-pwsm:hover, 
.btn-pwsm:active:focus {
	background: #607D8B;
	color: #e2e2e2;
	outline: none;
}

.btn-secondary {
	--bs-btn-color: #fff;
	--bs-btn-bg: var(--bs-secondary);
 	--bs-btn-border-color: #6c757d;
 	--bs-btn-hover-color: #fff;
 	--bs-btn-hover-bg: hsl(var(--bs-secondary-hue), var(--bs-secondary-saturation), calc(var(--bs-secondary-lightness) + 5%)); 
 	--bs-btn-hover-border-color: hsl(var(--bs-secondary-hue), var(--bs-secondary-saturation), calc(var(--bs-secondary-lightness) + 5%)); 
 	--bs-btn-focus-shadow-rgb: 130,138,145;
 	--bs-btn-active-color: #fff;
 	--bs-btn-active-bg: hsl(var(--bs-secondary-hue), var(--bs-secondary-saturation), calc(var(--bs-secondary-lightness) + 10%));
 	--bs-btn-active-border-color: hsl(var(--bs-secondary-hue), var(--bs-secondary-saturation), calc(var(--bs-secondary-lightness) + 10%));
 	--bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
 	--bs-btn-disabled-color: #fff;
	--bs-btn-disabled-bg: hsl(var(--bs-secondary-hue), var(--bs-secondary-saturation), calc(var(--bs-secondary-lightness) - 5%));
 	--bs-btn-disabled-border-color: hsl(var(--bs-secondary-hue), var(--bs-secondary-saturation), calc(var(--bs-secondary-lightness) - 5%));
}

/* .col, .col-1, .col-10, .col-11, .col-12, .col-2, .col-3, .col-4, .col-5, .col-6, .col-7, .col-8, .col-9, .col-auto, .col-lg, .col-lg-1, .col-lg-10, .col-lg-11, .col-lg-12, .col-lg-2, .col-lg-3, .col-lg-4, .col-lg-5, .col-lg-6, .col-lg-7, .col-lg-8, .col-lg-9, .col-lg-auto, .col-md, .col-md-1, .col-md-10, .col-md-11, .col-md-12, .col-md-2, .col-md-3, .col-md-4, .col-md-5, .col-md-6, .col-md-7, .col-md-8, .col-md-9, .col-md-auto, .col-sm, .col-sm-1, .col-sm-10, .col-sm-11, .col-sm-12, .col-sm-2, .col-sm-3, .col-sm-4, .col-sm-5, .col-sm-6, .col-sm-7, .col-sm-8, .col-sm-9, .col-sm-auto, .col-xl, .col-xl-1, .col-xl-10, .col-xl-11, .col-xl-12, .col-xl-2, .col-xl-3, .col-xl-4, .col-xl-5, .col-xl-6, .col-xl-7, .col-xl-8, .col-xl-9, .col-xl-auto {
	padding-left: 5px;
	padding-right: 5px;
} */

.cursor-pointer {
	cursor: pointer;
}

.dropdown .dropdown-item {
	color: var(--text-primary-low-emp);
}

.dropdown .dropdown-item:hover {
	background-color: var(--bg-primary-24dp);
}

.dropdown .dropdown-item:hover, 
.dropdown .dropdown-toggle:active, 
.dropdown .dropdown-toggle.show {
	color: var(--text-primary-high-emp);
}

.dropdown.form-control .dropdown-toggle {
	border: none;
}

.dropdown .dropdown-toggle, 
.form-select {
	color: var(--text-primary-medium-emp);
 	width: 100%;
}

.dropdown-toggle::after {
	margin-left: auto;
}

.dropdown-menu {
	background: var(--color-primary-24dp);
	margin: .5rem !important; /* ALICE: deve contrastare stile in linea */
	max-height: 50vh;
	min-width: 100%;
 	overflow: auto;
}

.dropdown-menu-container {
	display: none;
	background: var(--bg-primary-8dp);
}

.dropdown-menu-container.show {
	display: flex;
	flex-direction: column;
}

.dropdown-menu-container .dropdown-item:hover {
	background: var(--bg-primary-12dp);
}

/* .form-inline .form-control {
	width: 100%;
} */

.form-control:focus {
 	border-color: var(--brand);
}

.fs-7 {
	font-size: 0.75rem;
}

.fs-8 {
	font-size: 0.5rem;
}

.client-field {
	font-size: 1.1rem;
}

.color-palette{
	display: grid; 
	gap: .5em; 
	grid-template-columns: 1fr 1fr 1fr;
}

.custom-checkbox {
	padding-left: 0;
}

.custom-checkbox > input[type=checkbox].form-check-input,
.custom-checkbox > input[type=radio].form-check-input {
	display: none;
}

.form-box {
	align-items: center;
	background: var(--bg-primary-8dp);
	border-radius: .375rem;
	display: flex;
	height: 100%;
	isolation: isolate;
	justify-content: center;
	left: 0;
	overflow: hidden;
	position: absolute;
	top: 0px;
	transition: .5s ease-in-out;
	width: 100%;
}

.form-box form {
	left: 0;
	padding: 0 10%;
	position: absolute;
	transition: .5s;
	width: 100%;
}

.form-box .signinForm {
	transition-delay: .25s;
}

.form-box .signupForm {
	left: 100%;
	transition-delay: 0s;
}

.form-check-input:checked {
 	background-color: var(--bs-secondary);
 	border-color: var(--bs-secondary);
}

.form-check-input:focus {
	border-color: hsl(var(--bs-secondary-hue), var(--bs-secondary-saturation), calc(var(--bs-secondary-lightness) + 15%));
 	outline: 0;
 	box-shadow: 0 0 0 0.25rem rgba(var(--bs-secondary-rgb), 25%);
}

.form-control,
.form-control-plaintext {
	color: var(--text-primary-medium-emp);
}

.form-control { 	
	background: none;
}

.form-control-plaintext {
	background: var(--bg-primary-24dp);
}

.form-control-plaintext {
	border: 2px solid transparent;
}

/* input[type=search].form-control, */
/* .dropdown .dropdown-toggle, */
.dropdown-toggle, 
.dropdown .dropdown-menu,
.dropdown-menu, 
.dropdown .dropdown-menu.show,
.form-control, 
.form-select,
.search-group > * {
	border: 2px solid var(--color-primary-24dp);
}

.form-control:focus {
	background-color: transparent;
	color: var(--text-primary-medium-emp);
	box-shadow: none;
}

.form-group label {
	color: var(--text-primary-high-emp);
	font-weight: 500;
}

.form-select {
	background-color: transparent;
	/* background-color: var(--color-primary-24dp); */
	background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}

.form-select:focus {
	border: 2px solid var(--brand);
	box-shadow: none;
}

/* .form-switch label {
	vertical-align: -4px;
} */

.form-switch .form-check-input:focus {
 	background-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
}
.form-switch .form-check-input:checked {
 	background-position: right center;
 	background-image: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
}

.formTray.closed {
	display: none;
}

.icon-admin, 
.icon-powerAdmin {
	color: var(--bs-danger);
}

.icon-owner {
	color: var(--bs-warning);
}

.icon-user,
.icon-powerUser {
	color: var(--bs-success);
}

.icon-play {
	padding-left: 0.2rem; /*Alice: correzione ottica*/
}

.icon-pencil.rounded-circle {
	padding: 0.75em;
 	font-size: 0.6rem;
}

.input-group-text {
	background: var(--bg-primary-24dp);
	color: var(--text-primary-high-emp);
}

.btn:has(.invalid),
.invalid {
	border: 2px solid var(--bs-danger);
	animation: shake 0.2s 2;
}

@keyframes shake {
	25% {
		translate: 6px 0;
	}
	50% {
		translate: -6px 0;
	}
	75% {
		translate: 6px 0;
	}
}

.item-list-box {
	height: 45vh;
	overflow: hidden; /* Dave: Questi servono, verificare con lunga lista progetti e lunga lista task*/
	overflow-y: auto; /* Dave: Questi servono, verificare con lunga lista progetti e lunga lista task*/
}

.list-group-item {
	padding: .7rem .25rem;
}

.locked {
	opacity: .5;
 	pointer-events: none;
}

.manualDtEndBox > *, 
.manualDtStartBox > * {
	display: inline-block;
	vertical-align: middle;
}

.manualDtEndBox > input, 
.manualDtStartBox > input, 
#taskListBox, 
#adminSelector, 
#projectListBox {
	color: #333333;
}

.ml-auto {
	margin-left: auto !important;
}

.modal-footer, 
.modal-header {
	border: none;
}
 
.mt-7 {
	margin-top: 4rem;
}

.nav-link {
	cursor: pointer;
}

.nav-tabs .nav-link {
	border: none;
}

.nav-link:focus, .nav-link:hover {
	color: var(--text-primary-high-emp);
}

.nav-tabs .nav-link.active {
	background-color: var(--text-primary-high-emp);
	color: var(--bg-primary);
}

.navbar {
	padding: .2rem 1rem;
}

.navbar-toggler-icon {
	height: 1.2em;
	width: 1.2em;
}

.nav-lateral-logo-icon {
	width: 2rem;
}

.nav-logo-icon {
	width: 1.2rem;
}

.nav-link {
	color: var(--text-primary-high-emp);
}

.nav-menu {
	border-radius: 0 0.375rem 0.375rem 0;
	height: fit-content;
	margin-top: .5rem;
}

.nav-menu.open {
	height: auto;
	margin-top: 0;
}

.nav-tabs .nav-link.active {
	background-color: var(--text-primary-high-emp);
}

.offcanvas-body {
	overflow: unset;
}

.organization-ref::before {
	/* background-color: white; */
	content: "";
	display: block;
	height: 100%;
	left: 1rem;
	position: absolute;
	top: 0;
	width: 5px;
}

.organization-ref-start-0::before {
	left: 0;
}

.profile-image {
	height: auto;
	width: 10rem;
}

.profile-image, 
.profile-image-sm {
	aspect-ratio: 1; 
}

img.profile-image {
	aspect-ratio: 1; 
	border-radius: 50%;
	object-fit: cover;
}

.profile-image-sm {
	object-fit: cover; 
	width: 1.5rem;
}

.profile-image-edit {
	position: relative;
	transition: opacity .2s ease-in-out;
}

.profile-image-edit:hover .profile-image {
	opacity: .5;
}

.profile-image-edit:hover .profile-image-edit-content {
	opacity: 1;
}

.profile-image-edit a.dropdown-toggle {
	text-decoration: none;
}

.profile-image-edit a.dropdown-toggle::after {
	display: none;
}

/* Alice: non sapevo come altro selezionarla */
.profile-image-edit div.dropdown-menu-container {
 	left: 50%;
 	position: absolute;
 	top: 50%;
}

.profile-image-edit-content {
	position: absolute;
	top: 0;
	right: 0;
	bottom: 0;
	left: 0;
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	color: white;
	opacity: 0;
	transition: opacity .2s ease-in-out;
}

.profile-image-edit-content .icon-pencil {
	font-size: 2.5rem;
}

.profile-default-icon {
	font-size: 4rem;
}

.profile-default-icon, 
.profile-default-icon-sm { 
	align-items: center;
	aspect-ratio: 1;
 	background: var(--brand);
 	border-radius: 50%;
 	display: flex;
	font-weight: bold;
 	justify-content: center;
 	line-height: 1em;
	text-align: center;
}

.profile-default-icon-sm {
	font-size: 0.7rem;
 	height: calc(1.275rem + 0.3vw);
	padding: 0.3em;
}

.ps-45 {
	padding-left: 2rem;
}

.row {
	margin: 0;
}

.search-group > * {
	background: var(--bg-primary-24dp);
	color: var(--text-primary-low-emp);
}

.search-group.active-filter > * {
	background: var(--bs-warning);
	border: 2px solid var(--bs-warning);
	color: var(--bg-primary);
}

/* .search-group.active-filter input[type=search].form-control {
	border: none;
} */

.scrollbar-hidden {
	-ms-overflow-style: none;
	scrollbar-width: none; /* Firefox */
}

.scrollbar-hidden::-webkit-scrollbar {
	display: none;
}

.sign-box {
	isolation: isolate;
	height: 150px;
}

.sign-container {
	position: relative;
}

.sign-container > * {
	height: 360px;
}

.sign-view.up-active .sign-container > * {
	height: 650px;
}

.sign-container .row [class^="col-"] {
	background: hsla(0, 0%, 100%, .2);
	box-shadow: 0 5px 45px hsla(0, 0%, 0%, .15);
}

.sign-container .row div:first-of-type{
	border-radius: .375rem .375rem 0 0;
}

.sign-container .row div:last-of-type{
	border-radius: 0 0 .375rem .375rem;
}

.sign-view {
	align-items: center;
	background: var(--bg-primary);
	height: 100%;
	min-height: 100vh;
	/* padding-top: 5em; */
	text-align: center;
	transition: .5s;
}

.sign-view .signup {
	margin-top: 210px;
}

.sign-view.up-active {
	background: var(--brand);
}

.sign-view.up-active .form-box {
	left: 0;
	top: 150px;
}

.sign-view .sign-box.signin {
 	margin-top: 20px;
}

.sign-view.up-active .form-box .signinForm {
	left: -100%;
	transition-delay: 0s;
}

.sign-view.up-active .form-box .signupForm {
	left: 0;
	transition-delay: .25s;
}

.sign-view.up-active .signup {
	margin-top: 0;
}


.singleClient {
	border-bottom: var(--bs-border-width) solid rgba(var(--client-rgb), .2);
}

[id^="sessionList_"] .singleSession {
 	border-bottom: var(--bs-border-width) solid rgba(var(--ws-rgb), .2);
}

[id^="client_"] .singleProject {
 	border-bottom: var(--bs-border-width) solid rgba(var(--project-rgb), .2);
}

[id^="prj_"] .singleTask {
 	border-bottom: var(--bs-border-width) solid rgba(var(--task-rgb), .2);
}

.singleClient .row, 
[id^="sessionList_"] .singleSession .row, 
[id^="client_"] .singleProject .row, 
[id^="prj_"] .singleTask {
	align-items: center;
}

.single-table-row {
	display: none !important;
}

.single-table-row.render {
	display: block !important;
}

.singleTask {
	display: none !important;
	/* padding: .3rem; */
}

.singleTask.render {
	display: block !important;
}

/* Dave:Schifo */
.singleStatsTask.render {
	display: flex !important;
}

.spinner-lg {
	font-size: 2em;
	height: 3em;
	width: 3em;
}

.swap-icon-checkbox > input[type=checkbox].form-check-input ~ label::before {
 	font-family: 'timecorder' !important;
 	speak: never;
 	font-style: normal;
 	font-weight: normal;
 	font-variant: normal;
 	text-transform: none;
 	line-height: 1;

 	/* Better Font Rendering =========== */
 	-webkit-font-smoothing: antialiased;
 	-moz-osx-font-smoothing: grayscale;

	margin-right: .5rem;
}

.swap-icon-checkbox.permission-checkbox > input[type=checkbox].form-check-input ~ label::before {
	color: var(--bs-danger);
	content: "\\e93d";
	font-size: 1.2rem;
} 

.swap-icon-checkbox.permission-checkbox > input[type=checkbox].form-check-input:checked ~ label::before {
	color: var(--bs-success);
	content: "\\e941";
} 

.swap-icon-checkbox.visibility-checkbox > input[type=checkbox].form-check-input ~ label::before{
	content: "\\e940"; 
} 

.swap-icon-checkbox.visibility-checkbox > input[type=checkbox].form-check-input:checked ~ label::before{
	content: "\\e942"; 
} 

.swap-background-checkbox > input[type=checkbox].form-check-input ~ label,
.swap-background-checkbox > input[type=radio].form-check-input ~ label {
	display: block;
}

.swap-background-checkbox > input[type=checkbox].form-check-input:checked ~ label,
.swap-background-checkbox > input[type=radio].form-check-input:checked ~ label {
	background: var(--bg-primary-30dp);
	color: var(--text-primary-high-emp);
}

.table-row {
	border-bottom: 1px solid var(--color-primary-8dp);
	position: relative;
}

.table-row.active,
.selected {
 	background-color: rgba(var(--brand-rgb), .3);
}

.table-row:first-of-type {
	border-top-style: solid;
	border-top-width: 1px;
	border-top-color: var(--color-primary-8dp);
}

.table-row.single-table-row {
	padding: .5rem 1rem .5rem calc(1.5rem + 5px);
}

.tabular-nums {
	font-variant: tabular-nums;
}

.text-color-2 {
	color: var(--color-2);
}

.text-color-3 {
	color: var(--color-3);
}

.text-color-4 {
	color: var(--color-4);
}

.text-color-5 {
	color: var(--color-5);
}

.text-color-6 {
	color: var(--color-6);
}

.text-color-7 {
	color: var(--color-7);
}

.text-color-8 {
	color: var(--color-8);
}

.text-color-9 {
	color: var(--color-9);
}

.text-color-10 {
	color: var(--color-10);
}

.text-color-11 {
	color: var(--color-11);
}

.text-color-12 {
	color: var(--color-12);
}

.text-danger {
	color: var(--bs-danger) !important;
}

.text-primary {
	color: var(--brand) !important;
}

.text-secondary {
	color: var(--bs-secondary) !important;
}

.text-warning {
	color: var(--bs-warning) !important;
} 

.text-high-emp {
	color: var(--text-primary-high-emp);
}

.text-low-emp {
	color: var(--text-primary-low-emp);
}

.text-medium-emp {
	color: var(--text-primary-medium-emp);
}

.text-client {
	color: var(--client);
}

.text-project {
	color: var(--project);
}

.text-task {
	color: var(--task);
}

.text-ws {
	color: var(--ws);
}

/* .topBtnBox > * {
	display: inline-block;
	margin-bottom: 5px!important;
	vertical-align: middle;
} */

.to-hover:hover .to-show {
	display: block; 
}

.to-show {
	display: block;
}

.user-dropdown {
	max-height: calc(((1.5rem + 0.5rem + .125rem + (var(--bs-dropdown-item-padding-y) * 2)) * 12) + 1rem);
	/* overflow: scroll; Alice.Warn: "scroll" significa forza lo scroll sia che serva sia che non serva, quindi compare la scrollbar anche in orizontale*/
	overflow: auto;/* ..."auto", invece, signica "mostra le scrollbar solo se servono, solo dove servono" */
}

.wait-box-local {
	align-items: center;
	background-color: rgba(128, 128, 128, .6);
	bottom: 0;
	display: flex;
	justify-content: center;
	left: 0;
	pointer-events: none;
	position: absolute;
	right: 0;
	top: 0;
	z-index: 99;
}

.w-fit-content {
	width: fit-content;
}

.w-max-content {
	width: max-content;
}

#adminSelectorBox {
	margin-bottom: 20px;
}

#adminSelectorBox .input-group-addon {
 	background: #666666;
 	color: #e2e2e2;
 	outline: none;
}

#autoSaveTimeOutBar {
	background-color: #398439;
	bottom: 0;
	display: none;
	height: 4px;
	margin: 0 5px;
	position: absolute;
	right: 5px;
	transition: none;
	width: calc(100% - 10px);
}

#autoSaveTimeOutBar.running {
	background-color: #e95317;
	transition: all 3s linear;
	width: 0%;
}

#burgerBtn {
	z-index: 1050;
}

.collapsed #elapsedTimeCollapsed {
	display: block;
}

/* #filterRangeDateBox {
	width: 300px;
} */

/* #filterUserBox {
	width: 200px;
} */

#filterUserField {
	border-left-color: #343a40;
}

#loginForm .has-error {
	background-color: #f2dede;
	border-color: #a94442;
	-webkit-box-shadow: inset 0 1px 1px rgba(0, 0, 0, .075);
	box-shadow: inset 0 1px 1px rgba(0, 0, 0, .075);
}

#logOutBtn {
	margin: 0;
}

/* #newProjectTray, */
#newTaskTray, 
#projectPermissionTray,
#taskPermissionTray {
	background-color: #333333;
	border-radius: 0 0 10px 10px;
	box-shadow: 3px 7px 10px rgba(0, 0, 0, 0.5);
	left: 5px;
	padding: 10px;
	position: absolute;
	right: 5px;
	top: 67px;
	z-index: 99;
}

#statsContainer:has(.reportTab) #filterColumn {
	display: none;
}

#statsContainer:has(.reportTab.active) #filterColumn {
	display: flex;
}

#taskListBox, 
#projectListBox {
	/*border: 1px solid #000000;*/
	border-radius: 5px 0 0 5px;
	margin-bottom: 15px;
}

#taskListBox ul, 
#projectListBox ul {
	height: 100%;
	overflow: hidden;
 	overflow-y: auto;
}

#taskListBox > .list-group, 
#projectListBox > .list-group {
	/* height: 100%; */
	margin-bottom: 0;
}

#taskListBox > .list-group li, 
#projectListBox > .list-group li {
	border-radius: 0;
	/* cursor: pointer; */
	/* font-size: .7rem; */
	line-height: 1.2em;
	white-space: nowrap;
}

#projectContextMenu, 
#taskContextMenu {
	position: fixed;
}

/* #projectListBox > .list-group > li * {
	pointer-events: none;
} */

#searchBox {
	width: 250px;
}

#serverPathBox {
 	margin-bottom: 20px;
}

#serverPathBox > div {
 	margin-bottom: 0;
}

#wait-box {
 	align-items: center;
	background-color: rgba(255, 255, 255, .7);
	bottom: 0;
 	display: flex;
 	flex-direction: column;
 	justify-content: center;
	left: 0;
	position: fixed;
	right: 0;
	top: 0;
	z-index: 99999999;
}
/* TODO: ragionarci sopra 
.container-filters, 
.container-sort {
	container-type: inline-size;
	container-name: sort;
}

.container-filters .filter-label, 
.container-filters .filter-title, 
.container-sort .sort-label, 
.container-sort .sort-title {
	display: none;
}

.container-filters .filter-icon, 
.container-sort .sort-icon {
	display: inline;
}

@container (min-width: 300px){	
	.container-sort .sort-title {
		display: inline;
	}
	.container-filter .filter-title {
		display: inline;
	}
	.container-filter .filter-title {
		display: inline;
	}
}

@container (min-width: 400px){	
	.container-sort .sort-title {
		display: none;
	}
}

@container (min-width: 450px){	
	.container-filters .filter-label {
		display: inline;
	}

	.container-filters .filter-title {
		display: none;
	}
}

@container (min-width: 500px){	
	.container-sort .sort-label {
		display: inline;
	}
	.container-sort .sort-title {
		display: inline;
	}
	.container-filters .filter-title {
		display: inline;
	}
} 
*/

@media (min-width: 576px) { 
	.w-sm-auto {
		width: auto !important;
	}
}

@media (min-width: 768px) { 
	body.isRunningWorkSession {
		padding-bottom: calc(1.5rem + 1.5rem + 1rem + ((1rem + 1.5rem) * 3) + 1.5rem);
	}

	body[data-page-id="signView"] {
		padding-bottom:0;
	}
	
	.bg-levels {
		background-color: transparent;
	}

	.dropdown-menu {
		max-width: none;
	}

	.ps-md-45 {
		padding-left: 2rem !important;
	}

	.table-row.single-table-row {
		padding: .8rem 1rem .8rem calc(1.5rem + 5px);
	}

	.to-show {
		display: none;
	}
}

@media (max-width: 991.98px) and (orientation: landscape) {
	.sign-view {
		min-height: 100vw;
	}
}

@media (min-width: 992px) { 
	.btn, 
	.dropdown-menu-container, 
	.swap-background-checkbox > input[type=checkbox].form-check-input:checked ~ label,
	.swap-background-checkbox > input[type=radio].form-check-input:checked ~ label,
	.form-control, 
	.form-control-plaintext, 
	.form-select, 
	.input-group input, 
	.input-group-text {
		line-height: 1.5em;
	} 

	.form-box {
		box-shadow: 0 5px 45px hsla(0, 0%, 0%, .25);
		top: 0;
		width: 50%;
	}

	.form-box form {
		padding: 0 15%;
	}

	.ps-lg-45 {
		padding-left: 2rem !important;
	}

	.sign-container > * {
		height: 500px;
	}

	.sign-container .row {
		align-items: center!important;
	}

	.sign-container .row div:first-of-type{
		border-radius: .375rem 0 0 .375rem ;
	}

	.sign-container .row div:last-of-type{
		border-radius: 0 .375rem .375rem 0;
	}

	.sign-container .row [class^="col-"] {
		height: 420px;
	}

	.sign-view {
		display: flex;
		justify-content: center;
		min-height: 100vh;
	}

	.sign-view.up-active .form-box {
		left: 50%;
		top: 0;
	}

	.sign-view .sign-box.signin, 
	.sign-view .sign-box.signup, 
	.sign-view.up-active .sign-box {
		margin-top: 150px;
	}

	.table-row.single-table-row {
		padding: 1rem 1rem 1rem calc(2rem + 5px);
	}

	.w-lg-100 {
		width: 100% !important;
	}
}

@media (min-width: 1200px) { 
	.w-xl-auto {
		width: auto !important;
	}
}


/* ---------- Questa roba andrà spostata nel componente taskListPanel quando ci sarà */
#taskListBox .status-2 {
	background-color: #4b4b4b;
	opacity: .5;
}

#taskListBox .status-7 {
	background-color: #3b1f1f;
	opacity: .5;
}`, "",{"version":3,"sources":["webpack://./src/css/custom.css"],"names":[],"mappings":"AAAA,iBAAiB;;AAEjB,4FAA4F;;AAE5F,2CAA2C;AAE3C,8KAA8K;;AAG9K;CACC,qBAAqB,EAAE,iBAAiB;CACxC,+BAA+B,EAAE,iBAAiB;CAClD,yBAAyB;CACzB,yBAAyB;CACzB,yBAAyB;CACzB,yBAAyB;CACzB,0BAA0B;CAC1B,0BAA0B;CAC1B,0BAA0B;;CAE1B,4BAA4B;CAC5B,6BAA6B,EAAE,iBAAiB;CAChD,6BAA6B;;CAE7B,wBAAwB;CACxB,gBAAgB;CAChB,wBAAwB;CACxB,sBAAsB;;CAEtB,8BAA8B;CAC9B,gCAAgC;CAChC,wBAAwB;;CAExB,oBAAoB;CACpB,kBAAkB;CAClB,8BAA8B;CAC9B,sCAAsC;CACtC,gCAAgC;CAChC,4CAA4C;CAC5C,uBAAuB;CACvB,8BAA8B;CAC9B,6BAA6B;CAC7B,qBAAqB;CACrB,4BAA4B;CAC5B,wBAAwB;CACxB,qBAAqB;CACrB,wBAAwB;CACxB,sBAAsB;;CAEtB,kBAAkB;CAClB,kBAAkB;CAClB,kBAAkB;CAClB,kBAAkB;CAClB,kBAAkB;CAClB,kBAAkB;CAClB,kBAAkB;CAClB,kBAAkB;CAClB,kBAAkB;CAClB,kBAAkB;CAClB,mBAAmB;CACnB,mBAAmB;CACnB,mBAAmB;;CAEnB,uBAAuB;CACvB,yBAAyB;;CAEzB,uDAAuD;CACvD,yDAAyD;CACzD,sDAAsD;AACvD;;AAEA;CACC,qBAAqB,EAAE,iBAAiB;CACxC,4BAA4B,EAAE,iBAAiB;CAC/C,sJAAsJ;CACtJ,sJAAsJ;CACtJ,wJAAwJ;CACxJ,wJAAwJ;CACxJ,yJAAyJ;CACzJ,yJAAyJ;CACzJ,yJAAyJ;CACzJ,4BAA4B;CAC5B,4BAA4B;CAC5B,6BAA6B,EAAE,iBAAiB;CAChD,6BAA6B;;CAE7B,wBAAwB;CACxB,gBAAgB;CAChB,wBAAwB;CACxB,sBAAsB;;CAEtB,8BAA8B;CAC9B,gCAAgC;CAChC,2BAA2B;;CAE3B,oBAAoB;CACpB,kBAAkB;CAClB,8BAA8B;CAC9B,sCAAsC;CACtC,iCAAiC;CACjC,4CAA4C;CAC5C,uBAAuB;CACvB,8BAA8B;CAC9B,6BAA6B;CAC7B,qBAAqB;CACrB,4BAA4B;CAC5B,yBAAyB;CACzB,qBAAqB;CACrB,wBAAwB;CACxB,uBAAuB;;CAEvB,kBAAkB;CAClB,kBAAkB;CAClB,kBAAkB;CAClB,kBAAkB;CAClB,kBAAkB;CAClB,kBAAkB;CAClB,kBAAkB;CAClB,kBAAkB;CAClB,kBAAkB;CAClB,kBAAkB;CAClB,mBAAmB;CACnB,mBAAmB;CACnB,mBAAmB;;CAEnB,qBAAqB;CACrB,uBAAuB;;CAEvB,uDAAuD;CACvD,yDAAyD;CACzD,sDAAsD;AACvD;;AAEA,UAAU;AACV;CACC,6BAA6B;AAC9B;;AAEA,UAAU;AACV;CACC,kCAAkC;AACnC;;AAEA,WAAW;AACX;CACC,wBAAwB;CACxB,qCAAqC;AACtC;;AAEA,oBAAoB;AACpB;CACC,8FAA8F;AAC/F;;CAEC,yCAAyC;AAC1C;;;GAGG;;CAEF,wBAAwB;AACzB;;GAEG;;CAEF,4BAA4B;AAC7B;;;GAGG;;CAEF,wBAAwB;AACzB;;;GAGG;;CAEF,4BAA4B;AAC7B;;GAEG;;CAEF,mBAAmB;AACpB;;GAEG;;CAEF,2CAA2C;AAC5C;;GAEG;;AAEH,8CAA8C;AAC9C,6BAA6B;;AAE7B;CACC,cAAc;CACd,aAAa;AACd;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,6BAA6B;CAC7B,mCAAmC;CACnC,oBAAoB;CACpB,eAAe;CACf,wBAAwB;AACzB;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,yDAAiP;AAClP;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,yDAAiP;AAClP;;AAEA;CACC,yEAAyE;AAC1E;;AAEA;CACC,gBAAgB;AACjB;;AAEA;;CAEC,gCAAgC;CAChC,gBAAgB;AACjB;;AAEA;CACC,uBAAuB;AACxB;;AAEA;CACC,gBAAgB;CAChB,cAAc;CACd,wBAAwB;CACxB,mBAAmB;AACpB;;AAEA;;;;CAIC,yBAAyB,EAAE,WAAW;CACtC,qBAAqB,EAAE,oBAAoB;CAC3C,iBAAiB,EAAE,oBAAoB;AACxC;;AAEA;CACC,YAAY;CACZ,qBAAqB;CACrB,mCAAmC;CACnC;AACD;;AAEA;CACC,iBAAiB;AAClB;;AAEA;CACC,wBAAwB;CACxB,WAAW;CACX,WAAW;AACZ;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,WAAW;CACX,YAAY;CACZ,eAAe;CACf,oDAAoD;CACpD,kCAAkC;CAClC,mBAAmB;CACnB,yBAAyB;AAC1B;;AAEA;CACC,oDAAoD;CACpD,yBAAyB;CACzB,cAAc;CACd,aAAa;CACb,kBAAkB;CAClB,wBAAwB;CACxB,eAAe;CACf,wBAAwB;CACxB,oBAAoB;AACrB;;AAEA;CACC,qCAAqC;AACtC;;AAEA;CACC,WAAW;CACX,YAAY;CACZ,eAAe;CACf,aAAa;CACb,oDAAoD;CACpD,qCAAqC;CACrC,mBAAmB;CACnB,yBAAyB;AAC1B;;AAEA;CACC,oDAAoD;CACpD,yBAAyB;CACzB,cAAc;CACd,aAAa;CACb,kBAAkB;CAClB,mBAAmB;CACnB,eAAe;AAChB;;AAEA;CACC,WAAW;CACX,YAAY;CACZ,eAAe;CACf,aAAa;CACb,uBAAuB;CACvB,yBAAyB;CACzB,oBAAoB;CACpB,kBAAkB;AACnB;;AAEA;CACC,mBAAmB;CACnB,yBAAyB;CACzB,mBAAmB;CACnB,oDAAoD;AACrD;;AAEA;CACC,mBAAmB;CACnB,yBAAyB;CACzB,kBAAkB;CAClB,oDAAoD;AACrD;;AAEA;CACC,oDAAoD;CACpD,yBAAyB;CACzB,cAAc;CACd,aAAa;CACb,kBAAkB;CAClB,mBAAmB;CACnB,eAAe;AAChB;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,yDAA8a;AAC/a;;AAEA;CACC,uPAAuP;CACvP,aAAa;CACb,QAAQ;CACR,YAAY;CACZ,wBAAwB;AACzB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;CACC,mCAAmC;AACpC;;AAEA;CACC,mBAAmB;CACnB,qCAAqC;CACrC,sBAAsB;AACvB;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,0CAA0C;AAC3C;;AAEA;;CAEC,iCAAiC;CACjC,mCAAmC;AACpC;;AAEA;GACG;;AAEH;CACC,mBAAmB;AACpB;;AAEA;CACC,iBAAiB;AAClB;;AAEA;CACC,UAAU;CACV,6BAA6B;CAC7B,YAAY;CACZ,gBAAgB;AACjB;;AAEA;CACC,kBAAkB;CAClB,qBAAqB;CACrB,WAAW;CACX,UAAU;AACX;;AAEA;;;;;CAKC,gCAAgC;AACjC;;AAEA;CACC,uCAAuC;AACxC;;AAEA;;;;;CAKC,2CAA2C,EAAE,kDAAkD;AAChG;;AAEA;CACC,uCAAuC;AACxC;;AAEA;;;;;CAKC,2CAA2C,EAAE,kDAAkD;AAChG;;AAEA;CACC,uCAAuC;AACxC;;AAEA;;;;;CAKC,2CAA2C,EAAE,kDAAkD;AAChG;;AAEA;CACC,uCAAuC;AACxC;;AAEA;;;;;CAKC,2CAA2C,EAAE,kDAAkD;AAChG;;AAEA;CACC,uCAAuC;AACxC;;AAEA;;;;;CAKC,2CAA2C,EAAE,kDAAkD;AAChG;;AAEA;CACC,uCAAuC;AACxC;;AAEA;;;;;CAKC,2CAA2C,EAAE,kDAAkD;AAChG;;AAEA;CACC,uCAAuC;AACxC;;AAEA;;;;;CAKC,2CAA2C,EAAE,kDAAkD;AAChG;;AAEA;CACC,uCAAuC;AACxC;;AAEA;;;;;CAKC,2CAA2C,EAAE,kDAAkD;AAChG;;AAEA;CACC,uCAAuC;AACxC;;AAEA;;;;;CAKC,2CAA2C,EAAE,kDAAkD;AAChG;;AAEA;CACC,uCAAuC;AACxC;;AAEA;;;;;CAKC,4CAA4C,EAAE,kDAAkD;AACjG;;AAEA;CACC,wCAAwC;;AAEzC;;AAEA;;;;;CAKC,4CAA4C,EAAE,kDAAkD;AACjG;;AAEA;CACC,wCAAwC;AACzC;;AAEA;;;;;CAKC,4CAA4C,EAAE,kDAAkD;AACjG;;AAEA;CACC,wCAAwC;AACzC;;;AAGA;CACC,kBAAkB;AACnB;;AAEA;CACC,mCAAmC;AACpC;;AAEA;CACC,6CAA6C;AAC9C;;AAEA;;GAEG;;AAEH;CACC,yCAAyC;AAC1C;;AAEA;CACC,gDAAgD;AACjD;;AAEA;CACC,8CAA8C;AAC/C;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,6BAA6B;AAC9B;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,kDAAkD;CAClD,UAAU;AACX;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,mBAAmB;CACnB,YAAY;CACZ,mBAAmB,EAAE,wEAAwE;AAC9F;;AAEA,oBAAoB;AACpB;;;;;;;;;CASC,YAAY;CACZ,uBAAuB;CACvB,kBAAkB;CAClB,qBAAqB;AACtB;;AAEA;CACC,2CAA2C;AAC5C;;AAEA;CACC,mCAAmC;EAClC,kCAAkC;AACpC;;AAEA;;CAEC,WAAW;CACX,oBAAoB;AACrB;;AAEA;EACE,oBAAoB;EACpB,sCAAsC;EACtC,gDAAgD;EAChD,0BAA0B;EAC1B,0BAA0B;EAC1B,oCAAoC;EACpC,mCAAmC;EACnC,2BAA2B;EAC3B,2BAA2B;EAC3B,qCAAqC;EACrC,4DAA4D;EAC5D,6BAA6B;EAC7B,6BAA6B;EAC7B,uCAAuC;AACzC;;AAEA;CACC,eAAe;CACf,uBAAuB;CACvB,cAAc;CACd,YAAY;AACb;;AAEA;CACC,iBAAiB;CACjB,cAAc;EACb,cAAc;CACf,aAAa;AACd;;AAEA;CACC,gBAAgB;AACjB;;AAEA;;;CAGC,qCAAqC;AACtC;;AAEA;;CAEC,mCAAmC;AACpC;;AAEA;;;;CAIC,kCAAkC;AACnC;;AAEA;CACC,iGAAiG;CACjG,kCAAkC;CAClC,mCAAmC;AACpC;;;AAGA;CACC,mCAAmC;CACnC,4HAA4H;CAC5H,6HAA6H;AAC9H;;AAEA;EACE,oBAAoB;EACpB,yBAAyB;EACzB,mCAAmC;EACnC,0BAA0B;EAC1B,oGAAoG;EACpG,8GAA8G;EAC9G,qCAAqC;EACrC,2BAA2B;EAC3B,sGAAsG;EACtG,gHAAgH;EAChH,4DAA4D;EAC5D,6BAA6B;EAC7B,uGAAuG;EACvG,iHAAiH;AACnH;;AAEA;;;GAGG;;AAEH;CACC,wBAAwB;AACzB;;AAEA;CACC,mBAAmB;CACnB,yBAAyB;CACzB,cAAc;CACd,aAAa;AACd;;AAEA;;;CAGC,mBAAmB;CACnB,cAAc;CACd,aAAa;AACd;;AAEA;CACC,oBAAoB;CACpB,gCAAgC;EAC/B,8BAA8B;EAC9B,0BAA0B;EAC1B,yHAAyH;EACzH,mIAAmI;EACnI,sCAAsC;EACtC,2BAA2B;EAC3B,2HAA2H;EAC3H,qIAAqI;EACrI,4DAA4D;EAC5D,6BAA6B;CAC9B,4HAA4H;EAC3H,sIAAsI;AACxI;;AAEA;;;GAGG;;AAEH;CACC,eAAe;AAChB;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,wCAAwC;AACzC;;AAEA;;;CAGC,mCAAmC;AACpC;;AAEA;CACC,YAAY;AACb;;AAEA;;CAEC,qCAAqC;EACpC,WAAW;AACb;;AAEA;CACC,iBAAiB;AAClB;;AAEA;CACC,qCAAqC;CACrC,wBAAwB,EAAE,2CAA2C;CACrE,gBAAgB;CAChB,eAAe;EACd,cAAc;AAChB;;AAEA;CACC,aAAa;CACb,iCAAiC;AAClC;;AAEA;CACC,aAAa;CACb,sBAAsB;AACvB;;AAEA;CACC,kCAAkC;AACnC;;AAEA;;GAEG;;AAEH;EACE,0BAA0B;AAC5B;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,iBAAiB;AAClB;;AAEA;CACC,iBAAiB;AAClB;;AAEA;CACC,aAAa;CACb,SAAS;CACT,kCAAkC;AACnC;;AAEA;CACC,eAAe;AAChB;;AAEA;;CAEC,aAAa;AACd;;AAEA;CACC,mBAAmB;CACnB,iCAAiC;CACjC,sBAAsB;CACtB,aAAa;CACb,YAAY;CACZ,kBAAkB;CAClB,uBAAuB;CACvB,OAAO;CACP,gBAAgB;CAChB,kBAAkB;CAClB,QAAQ;CACR,2BAA2B;CAC3B,WAAW;AACZ;;AAEA;CACC,OAAO;CACP,cAAc;CACd,kBAAkB;CAClB,eAAe;CACf,WAAW;AACZ;;AAEA;CACC,sBAAsB;AACvB;;AAEA;CACC,UAAU;CACV,oBAAoB;AACrB;;AAEA;EACE,qCAAqC;EACrC,iCAAiC;AACnC;;AAEA;CACC,qHAAqH;EACpH,UAAU;EACV,4DAA4D;AAC9D;;AAEA;;CAEC,qCAAqC;AACtC;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,6BAA6B;AAC9B;;AAEA,qCAAqC;AACrC,gCAAgC;AAChC;;;;;;;CAOC,2CAA2C;AAC5C;;AAEA;CACC,6BAA6B;CAC7B,qCAAqC;CACrC,gBAAgB;AACjB;;AAEA;CACC,mCAAmC;CACnC,gBAAgB;AACjB;;AAEA;CACC,6BAA6B;CAC7B,iDAAiD;CACjD,yDAAiP;AAClP;;AAEA;CACC,8BAA8B;CAC9B,gBAAgB;AACjB;;AAEA;;GAEG;;AAEH;EACE,yDAA0J;AAC5J;AACA;EACE,iCAAiC;EACjC,yDAAuJ;AACzJ;;AAEA;CACC,aAAa;AACd;;AAEA;;CAEC,uBAAuB;AACxB;;AAEA;CACC,wBAAwB;AACzB;;AAEA;;CAEC,wBAAwB;AACzB;;AAEA;CACC,oBAAoB,EAAE,2BAA2B;AAClD;;AAEA;CACC,eAAe;EACd,iBAAiB;AACnB;;AAEA;CACC,kCAAkC;CAClC,mCAAmC;AACpC;;AAEA;;CAEC,kCAAkC;CAClC,uBAAuB;AACxB;;AAEA;CACC;EACC,gBAAgB;CACjB;CACA;EACC,iBAAiB;CAClB;CACA;EACC,gBAAgB;CACjB;AACD;;AAEA;CACC,YAAY;CACZ,gBAAgB,EAAE,gFAAgF;CAClG,gBAAgB,EAAE,gFAAgF;AACnG;;AAEA;CACC,qBAAqB;AACtB;;AAEA;CACC,WAAW;EACV,oBAAoB;AACtB;;AAEA;;CAEC,qBAAqB;CACrB,sBAAsB;AACvB;;AAEA;;;;;CAKC,cAAc;AACf;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;;CAEC,YAAY;AACb;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,eAAe;AAChB;;AAEA;CACC,YAAY;AACb;;AAEA;CACC,mCAAmC;AACpC;;AAEA;CACC,8CAA8C;CAC9C,wBAAwB;AACzB;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,aAAa;CACb,YAAY;AACb;;AAEA;CACC,WAAW;AACZ;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,mCAAmC;AACpC;;AAEA;CACC,oCAAoC;CACpC,mBAAmB;CACnB,iBAAiB;AAClB;;AAEA;CACC,YAAY;CACZ,aAAa;AACd;;AAEA;CACC,8CAA8C;AAC/C;;AAEA;CACC,eAAe;AAChB;;AAEA;CACC,6BAA6B;CAC7B,WAAW;CACX,cAAc;CACd,YAAY;CACZ,UAAU;CACV,kBAAkB;CAClB,MAAM;CACN,UAAU;AACX;;AAEA;CACC,OAAO;AACR;;AAEA;CACC,YAAY;CACZ,YAAY;AACb;;AAEA;;CAEC,eAAe;AAChB;;AAEA;CACC,eAAe;CACf,kBAAkB;CAClB,iBAAiB;AAClB;;AAEA;CACC,iBAAiB;CACjB,aAAa;AACd;;AAEA;CACC,kBAAkB;CAClB,mCAAmC;AACpC;;AAEA;CACC,WAAW;AACZ;;AAEA;CACC,UAAU;AACX;;AAEA;CACC,qBAAqB;AACtB;;AAEA;CACC,aAAa;AACd;;AAEA,8CAA8C;AAC9C;EACE,SAAS;EACT,kBAAkB;EAClB,QAAQ;AACV;;AAEA;CACC,kBAAkB;CAClB,MAAM;CACN,QAAQ;CACR,SAAS;CACT,OAAO;CACP,aAAa;CACb,sBAAsB;CACtB,uBAAuB;CACvB,mBAAmB;CACnB,YAAY;CACZ,UAAU;CACV,mCAAmC;AACpC;;AAEA;CACC,iBAAiB;AAClB;;AAEA;CACC,eAAe;AAChB;;AAEA;;CAEC,mBAAmB;CACnB,eAAe;EACd,wBAAwB;EACxB,kBAAkB;EAClB,aAAa;CACd,iBAAiB;EAChB,uBAAuB;EACvB,gBAAgB;CACjB,kBAAkB;AACnB;;AAEA;CACC,iBAAiB;EAChB,8BAA8B;CAC/B,cAAc;AACf;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,SAAS;AACV;;AAEA;CACC,kCAAkC;CAClC,kCAAkC;AACnC;;AAEA;CACC,6BAA6B;CAC7B,mCAAmC;CACnC,wBAAwB;AACzB;;AAEA;;GAEG;;AAEH;CACC,wBAAwB;CACxB,qBAAqB,EAAE,YAAY;AACpC;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,kBAAkB;CAClB,aAAa;AACd;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,iCAAiC;CACjC,2CAA2C;AAC5C;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,mBAAmB;CACnB,6BAA6B;CAC7B,YAAY;CACZ,iBAAiB;CACjB,sBAAsB;CACtB,kBAAkB;CAClB,eAAe;AAChB;;AAEA;CACC,iBAAiB;AAClB;;AAEA;CACC,wBAAwB;AACzB;;AAEA;CACC,OAAO;CACP,UAAU;AACX;;AAEA;EACE,gBAAgB;AAClB;;AAEA;CACC,WAAW;CACX,oBAAoB;AACrB;;AAEA;CACC,OAAO;CACP,sBAAsB;AACvB;;AAEA;CACC,aAAa;AACd;;;AAGA;CACC,uEAAuE;AACxE;;AAEA;EACE,mEAAmE;AACrE;;AAEA;EACE,wEAAwE;AAC1E;;AAEA;EACE,qEAAqE;AACvE;;AAEA;;;;CAIC,mBAAmB;AACpB;;AAEA;CACC,wBAAwB;AACzB;;AAEA;CACC,yBAAyB;AAC1B;;AAEA;CACC,wBAAwB;CACxB,oBAAoB;AACrB;;AAEA;CACC,yBAAyB;AAC1B;;AAEA,gBAAgB;AAChB;CACC,wBAAwB;AACzB;;AAEA;CACC,cAAc;CACd,WAAW;CACX,UAAU;AACX;;AAEA;EACE,oCAAoC;EACpC,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,oBAAoB;EACpB,oBAAoB;EACpB,cAAc;;EAEd,sCAAsC;EACtC,mCAAmC;EACnC,kCAAkC;;CAEnC,mBAAmB;AACpB;;AAEA;CACC,uBAAuB;CACvB,gBAAgB;CAChB,iBAAiB;AAClB;;AAEA;CACC,wBAAwB;CACxB,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;;CAEC,cAAc;AACf;;AAEA;;CAEC,kCAAkC;CAClC,mCAAmC;AACpC;;AAEA;CACC,iDAAiD;CACjD,kBAAkB;AACnB;;AAEA;;EAEE,4CAA4C;AAC9C;;AAEA;CACC,uBAAuB;CACvB,qBAAqB;CACrB,0CAA0C;AAC3C;;AAEA;CACC,4CAA4C;AAC7C;;AAEA;CACC,0BAA0B;AAC3B;;AAEA;CACC,qBAAqB;AACtB;;AAEA;CACC,qBAAqB;AACtB;;AAEA;CACC,qBAAqB;AACtB;;AAEA;CACC,qBAAqB;AACtB;;AAEA;CACC,qBAAqB;AACtB;;AAEA;CACC,qBAAqB;AACtB;;AAEA;CACC,qBAAqB;AACtB;;AAEA;CACC,qBAAqB;AACtB;;AAEA;CACC,sBAAsB;AACvB;;AAEA;CACC,sBAAsB;AACvB;;AAEA;CACC,sBAAsB;AACvB;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,qCAAqC;AACtC;;AAEA;CACC,mCAAmC;AACpC;;AAEA;CACC,mCAAmC;AACpC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,qCAAqC;AACtC;;AAEA;CACC,oBAAoB;AACrB;;AAEA;CACC,qBAAqB;AACtB;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;;;;GAIG;;AAEH;CACC,cAAc;AACf;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,qGAAqG;CACrG,qJAAqJ;CACrJ,cAAc,CAAC,wFAAwF;AACxG;;AAEA;CACC,mBAAmB;CACnB,yCAAyC;CACzC,SAAS;CACT,aAAa;CACb,uBAAuB;CACvB,OAAO;CACP,oBAAoB;CACpB,kBAAkB;CAClB,QAAQ;CACR,MAAM;CACN,WAAW;AACZ;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,mBAAmB;AACpB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,aAAa;AACf;;AAEA;CACC,yBAAyB;CACzB,SAAS;CACT,aAAa;CACb,WAAW;CACX,aAAa;CACb,kBAAkB;CAClB,UAAU;CACV,gBAAgB;CAChB,wBAAwB;AACzB;;AAEA;CACC,yBAAyB;CACzB,yBAAyB;CACzB,SAAS;AACV;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,cAAc;AACf;;AAEA;;GAEG;;AAEH;;GAEG;;AAEH;CACC,0BAA0B;AAC3B;;AAEA;CACC,yBAAyB;CACzB,qBAAqB;CACrB,uDAAuD;CACvD,+CAA+C;AAChD;;AAEA;CACC,SAAS;AACV;;AAEA,qBAAqB;AACrB;;;CAGC,yBAAyB;CACzB,4BAA4B;CAC5B,2CAA2C;CAC3C,SAAS;CACT,aAAa;CACb,kBAAkB;CAClB,UAAU;CACV,SAAS;CACT,WAAW;AACZ;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,aAAa;AACd;;AAEA;;CAEC,6BAA6B;CAC7B,0BAA0B;CAC1B,mBAAmB;AACpB;;AAEA;;CAEC,YAAY;CACZ,gBAAgB;EACf,gBAAgB;AAClB;;AAEA;;CAEC,kBAAkB;CAClB,gBAAgB;AACjB;;AAEA;;CAEC,gBAAgB;CAChB,qBAAqB;CACrB,sBAAsB;CACtB,kBAAkB;CAClB,mBAAmB;AACpB;;AAEA;;CAEC,eAAe;AAChB;;AAEA;;GAEG;;AAEH;CACC,YAAY;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;CACpB,yCAAyC;CACzC,SAAS;EACR,aAAa;EACb,sBAAsB;EACtB,uBAAuB;CACxB,OAAO;CACP,eAAe;CACf,QAAQ;CACR,MAAM;CACN,iBAAiB;AAClB;AACA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;CA0DC;;AAED;CACC;EACC,sBAAsB;CACvB;AACD;;AAEA;CACC;EACC,6EAA6E;CAC9E;;CAEA;EACC,gBAAgB;CACjB;;CAEA;EACC,6BAA6B;CAC9B;;CAEA;EACC,eAAe;CAChB;;CAEA;EACC,6BAA6B;CAC9B;;CAEA;EACC,4CAA4C;CAC7C;;CAEA;EACC,aAAa;CACd;AACD;;AAEA;CACC;EACC,iBAAiB;CAClB;AACD;;AAEA;CACC;;;;;;;;;EASC,kBAAkB;CACnB;;CAEA;EACC,2CAA2C;EAC3C,MAAM;EACN,UAAU;CACX;;CAEA;EACC,cAAc;CACf;;CAEA;EACC,6BAA6B;CAC9B;;CAEA;EACC,aAAa;CACd;;CAEA;EACC,6BAA6B;CAC9B;;CAEA;EACC,mCAAmC;CACpC;;CAEA;EACC,kCAAkC;CACnC;;CAEA;EACC,aAAa;CACd;;CAEA;EACC,aAAa;EACb,uBAAuB;EACvB,iBAAiB;CAClB;;CAEA;EACC,SAAS;EACT,MAAM;CACP;;CAEA;;;EAGC,iBAAiB;CAClB;;CAEA;EACC,wCAAwC;CACzC;;CAEA;EACC,sBAAsB;CACvB;AACD;;AAEA;CACC;EACC,sBAAsB;CACvB;AACD;;;AAGA,sFAAsF;AACtF;CACC,yBAAyB;CACzB,WAAW;AACZ;;AAEA;CACC,yBAAyB;CACzB,WAAW;AACZ","sourcesContent":["/* CSS Document */\r\n\r\n/* see https://getbootstrap.com/docs/5.3/customize/color-modes/#javascript for color switch*/\r\n\r\n/***************** fonts ******************/\r\n@import url(\"./fonts.css\");\r\n/* @import url('https://fonts.googleapis.com/css2?family=Rubik:ital,wght@0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap'); */\r\n@import url('https://fonts.googleapis.com/css2?family=Inter:wght@100;200;300;400;500;600;700;800;900&display=swap');\r\n\r\n:root body.theme-1 {\r\n\t--bg-primary: #e6e6e6; /*bg-primary-1dp*/\r\n\t--bg-primary-rgb: 230, 230, 230; /*bg-primary-1dp*/\r\n\t--bg-primary-1dp: #F5F5F5;\r\n\t--bg-primary-2dp: #F5F5F5;\r\n\t--bg-primary-5dp: #F5F5F5;\r\n\t--bg-primary-8dp: #ECECEC;\r\n\t--bg-primary-12dp: #d9d8d8;\r\n\t--bg-primary-24dp: #dadada;\r\n\t--bg-primary-30dp: #c4c4c4;\r\n\t\r\n\t--color-primary-8dp: #E1E1E1;\r\n\t--color-primary-24dp: #dadada; /*bg-primary-1dp*/\r\n\t--color-primary-30dp: #c4c4c4;\r\n\t\r\n\t--brand-rgb: 0, 128, 128;\r\n\t--brand-hue: 180;\r\n\t--brand-saturation: 100%;\r\n\t--brand-lightness: 25%;\r\n\r\n\t--brand: rgb(var(--brand-rgb)); \r\n\t--client: rgb(var(--client-rgb));\r\n\t--client-rgb: 0, 71, 185;\r\n\r\n\t--bs-danger: #FA7070; \r\n\t--bs-info: #19cfcf;\r\n\t--project: var(--bs-secondary);\r\n\t--project-rgb: var(--bs-secondary-rgb);\r\n\t--bs-secondary-rgb: 116, 77, 178;\r\n\t--bs-secondary: rgb(var(--bs-secondary-rgb)); \r\n\t--bs-secondary-hue: 263;\r\n\t--bs-secondary-saturation: 93%;\r\n\t--bs-secondary-lightness: 71%;\r\n\t--bs-success: #84e445;\r\n\t--task: rgb(var(--task-rgb));\r\n\t--task-rgb: 155, 72, 154;\r\n\t--bs-warning: #ffc107;\r\n\t--ws: rgb(var(--ws-rgb));\r\n\t--ws-rgb: 234, 88, 139;\r\n\r\n\t--color-0: #000000;\r\n\t--color-1: #6c757d;\r\n\t--color-2: #9fbe25;\r\n\t--color-3: #ffc107;;\r\n\t--color-4: #fd7e14;\r\n\t--color-5: #dc3545;\r\n\t--color-6: #d63384;\r\n\t--color-7: #6f42c1;\r\n\t--color-8: #6610f2;\r\n\t--color-9: #0d6efd;\r\n\t--color-10: #0dcaf0;\r\n\t--color-11: #198754;\r\n\t--color-12: #20c997;\r\n\t\r\n\t--scrollbar-width: 10px;\r\n\t--shadow-rgb: 200 200 200;\r\n\r\n\t--text-primary-high-emp: rgba(var(--bs-black-rgb), .87);\r\n\t--text-primary-medium-emp: rgba(var(--bs-black-rgb), .60);\r\n\t--text-primary-low-emp: rgba(var(--bs-black-rgb), .38);\r\n}\r\n\r\n:root body.theme-2 {\r\n\t--bg-primary: #121212; /*bg-primary-1dp*/\r\n\t--bg-primary-rgb: 18, 18, 18; /*bg-primary-1dp*/\r\n\t--bg-primary-1dp: linear-gradient(rgba(var(--bs-white-rgb), 5%), rgba(var(--bs-white-rgb), 5%)), linear-gradient(var(--bg-primary), var(--bg-primary));\r\n\t--bg-primary-2dp: linear-gradient(rgba(var(--bs-white-rgb), 7%), rgba(var(--bs-white-rgb), 7%)), linear-gradient(var(--bg-primary), var(--bg-primary));\r\n\t--bg-primary-5dp: linear-gradient(rgba(var(--bs-white-rgb), 10%), rgba(var(--bs-white-rgb), 10%)), linear-gradient(var(--bg-primary), var(--bg-primary));\r\n\t--bg-primary-8dp: linear-gradient(rgba(var(--bs-white-rgb), 12%), rgba(var(--bs-white-rgb), 12%)), linear-gradient(var(--bg-primary), var(--bg-primary));\r\n\t--bg-primary-12dp: linear-gradient(rgba(var(--bs-white-rgb), 14%), rgba(var(--bs-white-rgb), 14%)), linear-gradient(var(--bg-primary), var(--bg-primary));\r\n\t--bg-primary-24dp: linear-gradient(rgba(var(--bs-white-rgb), 16%), rgba(var(--bs-white-rgb), 16%)), linear-gradient(var(--bg-primary), var(--bg-primary));\r\n\t--bg-primary-30dp: linear-gradient(rgba(var(--bs-white-rgb), 24%), rgba(var(--bs-white-rgb), 24%)), linear-gradient(var(--bg-primary), var(--bg-primary));\r\n\t--color-primary-5dp: #2A2A2A;\t\r\n\t--color-primary-8dp: #2E2E2E;\t\r\n\t--color-primary-24dp: #383838; /*bg-primary-1dp*/\r\n\t--color-primary-30dp: #4B4B4B;\r\n\r\n\t--brand-rgb: 0, 128, 128;\r\n\t--brand-hue: 180;\r\n\t--brand-saturation: 100%;\r\n\t--brand-lightness: 25%;\r\n\r\n\t--brand: rgb(var(--brand-rgb)); \r\n\t--client: rgb(var(--client-rgb));\r\n\t--client-rgb: 112, 151, 250;\r\n\r\n\t--bs-danger: #FA7070; \r\n\t--bs-info: #70FAFA;\r\n\t--project: var(--bs-secondary);\r\n\t--project-rgb: var(--bs-secondary-rgb);\r\n\t--bs-secondary-rgb: 165, 112, 250;\r\n\t--bs-secondary: rgb(var(--bs-secondary-rgb)); \r\n\t--bs-secondary-hue: 263;\r\n\t--bs-secondary-saturation: 93%;\r\n\t--bs-secondary-lightness: 71%;\r\n\t--bs-success: #A7FA70;\r\n\t--task: rgb(var(--task-rgb));\r\n\t--task-rgb: 250, 112, 243;\r\n\t--bs-warning: #EEFA70;\r\n\t--ws: rgb(var(--ws-rgb));\r\n\t--ws-rgb: 250, 165, 112;\r\n\r\n\t--color-0: #ffffff;\r\n\t--color-1: #6c757d;\r\n\t--color-2: #9fbe25;\r\n\t--color-3: #ffc107;;\r\n\t--color-4: #fd7e14;\r\n\t--color-5: #dc3545;\r\n\t--color-6: #d63384;\r\n\t--color-7: #6f42c1;\r\n\t--color-8: #6610f2;\r\n\t--color-9: #0d6efd;\r\n\t--color-10: #0dcaf0;\r\n\t--color-11: #198754;\r\n\t--color-12: #20c997;\r\n\t\r\n\t--shadow-rgb: 0, 0, 0;\r\n\t--scrollbar-width: 10px;\r\n\r\n\t--text-primary-high-emp: rgba(var(--bs-white-rgb), .87);\r\n\t--text-primary-medium-emp: rgba(var(--bs-white-rgb), .60);\r\n\t--text-primary-low-emp: rgba(var(--bs-white-rgb), .38);\r\n}\r\n\r\n/* width */\r\n::-webkit-scrollbar {\r\n\twidth: var(--scrollbar-width);\r\n}\r\n\r\n/* Track */\r\n::-webkit-scrollbar-track {\r\n\tbackground: var(--bg-primary-12dp);\r\n}\r\n\r\n/* Handle */\r\n::-webkit-scrollbar-thumb {\r\n\tbackground: var(--brand);\r\n\tborder-radius: var(--scrollbar-width);\r\n}\r\n\r\n/* Handle on hover */\r\n::-webkit-scrollbar-thumb:hover {\r\n\tbackground: hsl(var(--brand-hue), var(--brand-saturation), calc(var(--brand-lightness) - 10%));\r\n}\r\n\r\n /* Chrome, Firefox, Opera, Safari 10.1+ */\r\n/* ::placeholder {\r\n\tcolor: var(--text-primary-low-emp) !important;\r\n\topacity: 1;\r\n} */\r\n\r\n /* WebKit, Blink, Edge */\r\n/* ::-webkit-input-placeholder {\r\n \tcolor: var(--text-primary-low-emp) !important;\r\n} */\r\n\r\n /* Mozilla Firefox 4 to 18 */\r\n/* :-moz-placeholder {\r\n \tcolor: var(--text-primary-low-emp) !important;\r\n \topacity: 1;\r\n} */\r\n\r\n /* Mozilla Firefox 19+ */\r\n/* ::-moz-placeholder {\r\n \tcolor: var(--text-primary-low-emp) !important;\r\n \topacity: 1;\r\n} */\r\n\r\n /* Internet Explorer 10-11 */\r\n/* :-ms-input-placeholder {\r\n \tcolor: var(--text-primary-low-emp) !important;\r\n} */\r\n\r\n /* Microsoft Edge */\r\n/* ::-ms-input-placeholder {\r\n \tcolor: var(--text-primary-low-emp) !important;\r\n} */\r\n\r\n /* Most modern browsers support this now. */\r\n/* ::placeholder {\r\n \tcolor: var(--text-primary-low-emp) !important;\r\n} */\r\n\r\n/******************** site *******************/\r\n/* TODO:metti tutto insieme */\r\n\r\na, a:hover {\r\n\tcolor: #e2e2e2;\r\n\toutline: none;\r\n}\r\n\r\na:hover {\r\n\tcolor: #3c763d;\r\n}\r\n\r\nbody {\r\n\tbackground: var(--bg-primary);\r\n\tcolor: var(--text-primary-high-emp);\r\n\t/* color: #212529; */\r\n\tcursor: default;\r\n\t/* based onWorkSession */\r\n}\r\n\r\nbody.theme-1 input {\r\n\tcolor-scheme: light;\r\n}\r\n\r\nbody.theme-1 .form-select {\r\n\tbackground-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3e%3cpath fill='none' stroke='%23c4c4c4' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='m2 5 6 6 6-6'/%3e%3c/svg%3e\");\r\n}\r\n\r\nbody.theme-2 input {\r\n\tcolor-scheme: dark;\r\n}\r\n\r\nbody.theme-2 .form-select {\r\n\tbackground-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3e%3cpath fill='none' stroke='%23ffffff' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='m2 5 6 6 6-6'/%3e%3c/svg%3e\");\r\n}\r\n\r\nbody.isRunningWorkSession {\r\n\tpadding-bottom: calc(1rem + .5rem + 1rem + .5rem + ((1.5rem) * 3) + 1rem);\r\n}\r\n\r\nbody[data-page-id=\"signView\"] {\r\n\tpadding-bottom:0;\r\n}\r\n\r\nbody, \r\nhtml {\r\n\tfont-family: \"Inter\", sans-serif;\r\n\tmin-height: 100%;\r\n}\r\n\r\nbutton.icon-.collapsed::before {\r\n\ttransform: rotate(0deg);\r\n}\r\n\r\nbutton.icon-:before {\r\n\tcontent: \"\\E905\";\r\n\tdisplay: block;\r\n\ttransform: rotate(90deg);\r\n\ttransition: .4s all;\r\n}\r\n\r\nh1, h2, h3, h4, h5, h6,\r\nlabel,\r\np, \r\n.prevent-select {\r\n\t-webkit-user-select: none; /* Safari */\r\n\t-ms-user-select: none; /* IE 10 and IE 11 */\r\n\tuser-select: none; /* Standard syntax */\r\n}\r\n\r\ninput {\r\n\tborder: none;\r\n\tborder-radius: 0.2rem;\r\n\tcolor: var(--text-primary-high-emp);\r\n\tpadding: 0.1rem 0.2rem\r\n}\r\n\r\ninput[type=number] {\r\n\ttext-align: right;\r\n}\r\n\r\ninput[type=range] {\r\n\t-webkit-appearance: none;\r\n\tmargin: 0 0;\r\n\twidth: 100%;\r\n}\r\n\r\ninput[type=range]:focus {\r\n\toutline: none;\r\n}\r\n\r\ninput[type=range]::-webkit-slider-runnable-track {\r\n\twidth: 100%;\r\n\theight: 1rem;\r\n\tcursor: pointer;\r\n\tbox-shadow: 0px 0px 0px #000000, 0px 0px 0px #000000;\r\n\tbackground: var(--bg-primary-12dp);\r\n\tborder-radius: 25px;\r\n\tborder: 0px solid #000000;\r\n}\r\n\r\ninput[type=range]::-webkit-slider-thumb {\r\n\tbox-shadow: 0px 0px 0px #000000, 0px 0px 0px #000000;\r\n\tborder: 0px solid #000000;\r\n\theight: 1.5rem;\r\n\twidth: 1.5rem;\r\n\tborder-radius: 50%;\r\n\tbackground: var(--brand);;\r\n\tcursor: pointer;\r\n\t-webkit-appearance: none;\r\n\tmargin-top: -0.25rem;\r\n}\r\n\r\ninput[type=range]:focus::-webkit-slider-runnable-track {\r\n\tbackground: var(--color-primary-24dp);\r\n}\r\n\r\ninput[type=range]::-moz-range-track {\r\n\twidth: 100%;\r\n\theight: 1rem;\r\n\tcursor: pointer;\r\n\tanimate: 0.2s;\r\n\tbox-shadow: 0px 0px 0px #000000, 0px 0px 0px #000000;\r\n\tbackground: var(--color-primary-24dp);\r\n\tborder-radius: 25px;\r\n\tborder: 0px solid #000000;\r\n}\r\n\r\ninput[type=range]::-moz-range-thumb {\r\n\tbox-shadow: 0px 0px 0px #000000, 0px 0px 0px #000000;\r\n\tborder: 0px solid #000000;\r\n\theight: 1.5rem;\r\n\twidth: 1.5rem;\r\n\tborder-radius: 7px;\r\n\tbackground: #65001c;\r\n\tcursor: pointer;\r\n}\r\n\r\ninput[type=range]::-ms-track {\r\n\twidth: 100%;\r\n\theight: 1rem;\r\n\tcursor: pointer;\r\n\tanimate: 0.2s;\r\n\tbackground: transparent;\r\n\tborder-color: transparent;\r\n\tborder-width: 39px 0;\r\n\tcolor: transparent;\r\n}\r\n\r\ninput[type=range]::-ms-fill-lower {\r\n\tbackground: #000000;\r\n\tborder: 0px solid #000000;\r\n\tborder-radius: 50px;\r\n\tbox-shadow: 0px 0px 0px #000000, 0px 0px 0px #000000;\r\n}\r\n\r\ninput[type=range]::-ms-fill-upper {\r\n\tbackground: #000000;\r\n\tborder: 0px solid #000000;\r\n\tborder-radius: 50%;\r\n\tbox-shadow: 0px 0px 0px #000000, 0px 0px 0px #0d0d0d;\r\n}\r\n\r\ninput[type=range]::-ms-thumb {\r\n\tbox-shadow: 0px 0px 0px #000000, 0px 0px 0px #000000;\r\n\tborder: 0px solid #000000;\r\n\theight: 1.5rem;\r\n\twidth: 1.5rem;\r\n\tborder-radius: 50%;\r\n\tbackground: #000000;\r\n\tcursor: pointer;\r\n}\r\n\r\ninput[type=range]:focus::-ms-fill-lower {\r\n\tbackground: #000000;\r\n}\r\n\r\ninput[type=range]:focus::-ms-fill-upper {\r\n\tbackground: #000000;\r\n}\r\n\r\ninput[type=search]::-webkit-search-cancel-button {\r\n\tbackground-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3E%3Cpath fill='%23000000' d='M8,10.7l5.3,5.3c0.1,0.1,0.2,0.1,0.3,0l2.4-2.4c0.1-0.1,0.1-0.2,0-0.3L10.7,8l5.2-5.2c0.1-0.1,0.1-0.2,0-0.3l-2.4-2.4 c-0.1-0.1-0.2-0.1-0.3,0L8,5.3L2.7,0.1C2.7,0,2.5,0,2.4,0.1L0.1,2.4C0,2.5,0,2.7,0.1,2.7L5.3,8l-5.3,5.3c-0.1,0.1-0.1,0.2,0,0.3 l2.4,2.4c0.1,0.1,0.2,0.1,0.3,0L8,10.7z'/%3E%3C/svg%3E%0A\");\r\n}\r\n\r\ninput[type=search]::-webkit-search-cancel-button {\r\n\t/* background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3e%3cpath fill='none' stroke='%23ffffff' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='m2 5 6 6 6-6'/%3e%3c/svg%3e\"); */\r\n\theight: .5rem;\r\n\tright: 0;\r\n\twidth: .5rem;\r\n\t-webkit-appearance: none;\r\n}\r\n\r\ninput[type=search].form-control {\r\n\tpadding-right: 0;\r\n}\r\n\r\ninput[type=search]::placeholder {\r\n \tcolor: var(--text-primary-low-emp);\r\n}\r\n\r\ntable th {\r\n\tcolor: var(--text-primary-high-emp);\r\n}\r\n\r\ntable td {\r\n\talign-items: center;\r\n\tcolor: var(--text-primary-medium-emp);\r\n\tvertical-align: middle;\r\n}\r\n\r\ntable td span.badge {\r\n\tdisplay: table-cell;\r\n}\r\n\r\ntable.table-striped>tbody>tr:nth-of-type(even)>* {\r\n\tbackground-color: var(--color-primary-5dp);\r\n}\r\n\r\ntable.table-striped>tbody>tr:nth-of-type(even)>*, \r\ntable.table-striped>tbody>tr:nth-of-type(odd)>* {\r\n\t--bs-table-accent-bg: transparent;\r\n\tcolor: var(--text-primary-high-emp);\r\n}\r\n\r\n/* table.table-striped>tbody>tr:nth-of-type(odd)>* {\r\n} */\r\n\r\ntable#tableStats td {\r\n\tvertical-align: top;\r\n}\r\n\r\ntable#tableStats th {\r\n\tpadding: 0 .25rem;\r\n}\r\n\r\ntable.table>:not(caption)>*>* {\r\n\tpadding: 0;\r\n\tbackground-color: transparent;\r\n\tborder: none;\r\n\tbox-shadow: none;\r\n}\r\n\r\n.activity-color-display {\r\n\tborder-radius: 50%;\r\n\tdisplay: inline-block;\r\n\theight: 2em;\r\n\twidth: 2em;\r\n}\r\n\r\n.activity-color-display.color-0, \r\n.bg-color-0, \r\n.color-0::before, \r\n.bg-color-0::before, \r\n.badge.color-0 {\r\n\tbackground-color: var(--color-0);\r\n}\r\n\r\n.border-color-0 {\r\n\tborder-color: var(--color-0) !important;\r\n}\r\n\r\n.activity-color-display.color-1, \r\n.bg-color-1, \r\n.color-1::before, \r\n.bg-color-1::before, \r\n.badge.color-1 {\r\n\tbackground-color: var(--color-1) !important; /* Dave: serve l'important se no vince il bianco */\r\n}\r\n\r\n.border-color-1 {\r\n\tborder-color: var(--color-1) !important;\r\n}\r\n\r\n.activity-color-display.color-2, \r\n.bg-color-2, \r\n.color-2::before, \r\n.bg-color-2::before, \r\n.badge.color-2 {\r\n\tbackground-color: var(--color-2) !important; /* Dave: serve l'important se no vince il bianco */\r\n}\r\n\r\n.border-color-2 {\r\n\tborder-color: var(--color-2) !important;\r\n}\r\n\r\n.activity-color-display.color-3, \r\n.bg-color-3, \r\n.color-3::before, \r\n.bg-color-3::before, \r\n.badge.color-3 {\r\n\tbackground-color: var(--color-3) !important; /* Dave: serve l'important se no vince il bianco */\r\n}\r\n\r\n.border-color-3 {\r\n\tborder-color: var(--color-3) !important;\r\n}\r\n\r\n.activity-color-display.color-4, \r\n.bg-color-4, \r\n.color-4::before, \r\n.bg-color-4::before, \r\n.badge.color-4 {\r\n\tbackground-color: var(--color-4) !important; /* Dave: serve l'important se no vince il bianco */\r\n}\r\n\r\n.border-color-4 {\r\n\tborder-color: var(--color-4) !important;\r\n}\r\n\r\n.activity-color-display.color-5, \r\n.bg-color-5, \r\n.color-5::before, \r\n.bg-color-5::before, \r\n.badge.color-5 {\r\n\tbackground-color: var(--color-5) !important; /* Dave: serve l'important se no vince il bianco */\r\n}\r\n\r\n.border-color-5 {\r\n\tborder-color: var(--color-5) !important;\r\n}\r\n\r\n.activity-color-display.color-6, \r\n.bg-color-6, \r\n.color-6::before, \r\n.bg-color-6::before, \r\n.badge.color-6 {\r\n\tbackground-color: var(--color-6) !important; /* Dave: serve l'important se no vince il bianco */\r\n}\r\n\r\n.border-color-6 {\r\n\tborder-color: var(--color-6) !important;\r\n}\r\n\r\n.activity-color-display.color-7, \r\n.bg-color-7, \r\n.color-7::before, \r\n.bg-color-7::before, \r\n.badge.color-7 {\r\n\tbackground-color: var(--color-7) !important; /* Dave: serve l'important se no vince il bianco */\r\n}\r\n\r\n.border-color-7 {\r\n\tborder-color: var(--color-7) !important;\r\n}\r\n\r\n.activity-color-display.color-8, \r\n.bg-color-8, \r\n.color-8::before, \r\n.bg-color-8::before, \r\n.badge.color-8 {\r\n\tbackground-color: var(--color-8) !important; /* Dave: serve l'important se no vince il bianco */\r\n}\r\n\r\n.border-color-8 {\r\n\tborder-color: var(--color-8) !important;\r\n}\r\n\r\n.activity-color-display.color-9, \r\n.bg-color-9, \r\n.color-9::before, \r\n.bg-color-9::before, \r\n.badge.color-9 {\r\n\tbackground-color: var(--color-9) !important; /* Dave: serve l'important se no vince il bianco */\r\n}\r\n\r\n.border-color-9 {\r\n\tborder-color: var(--color-9) !important;\r\n}\r\n\r\n.activity-color-display.color-10, \r\n.bg-color-10, \r\n.color-10::before, \r\n.bg-color-110::before, \r\n.badge.color-10 {\r\n\tbackground-color: var(--color-10) !important; /* Dave: serve l'important se no vince il bianco */\r\n}\r\n\r\n.border-color-10 {\r\n\tborder-color: var(--color-10) !important;\r\n\r\n}\r\n\r\n.activity-color-display.color-11, \r\n.bg-color-11, \r\n.color-11::before, \r\n.bg-color-111::before, \r\n.badge.color-11 {\r\n\tbackground-color: var(--color-11) !important; /* Dave: serve l'important se no vince il bianco */\r\n}\r\n\r\n.border-color-11 {\r\n\tborder-color: var(--color-11) !important;\r\n}\r\n\r\n.activity-color-display.color-12, \r\n.bg-color-12, \r\n.color-12::before, \r\n.bg-color-112::before, \r\n.badge.color-12 {\r\n\tbackground-color: var(--color-12) !important; /* Dave: serve l'important se no vince il bianco */\r\n}\r\n\r\n.border-color-12 {\r\n\tborder-color: var(--color-12) !important;\r\n}\r\n\r\n\r\n.badge-pill {\r\n\tmargin-right: .5em;\r\n}\r\n\r\n.bg-body {\r\n\tbackground-color: var(--bg-primary);\r\n}\r\n\r\n.bg-danger {\r\n\tbackground-color: var(--bs-danger) !important;\r\n}\r\n\r\n/* .bg-levels {\r\n\tbackground-color: rgba(var(--bs-white-rgb), .05);\r\n} */\r\n\r\n.bg-primary {\r\n\tbackground-color: var(--brand) !important;\r\n}\r\n\r\n.bg-secondary {\r\n\tbackground-color: var(--bs-secondary) !important;\r\n}\r\n\r\n.bg-warning {\r\n\tbackground-color: var(--bs-warning) !important;\r\n}\r\n\r\n.bg-client {\r\n\tbackground-color: var(--client);\r\n}\r\n\r\n.bg-project {\r\n\tbackground-color: var(--project) ;\r\n}\r\n\r\n.bg-task {\r\n\tbackground-color: var(--task) ;\r\n}\r\n\r\n.bg-ws {\r\n\tbackground-color: var(--ws) ;\r\n}\r\n\r\n.bg-0dp {\r\n\tbackground: var(--bg-primary);\r\n}\r\n\r\n.bg-1dp {\r\n\tbackground: var(--bg-primary-1dp);\r\n}\r\n\r\n.bg-2dp {\r\n\tbackground: var(--bg-primary-2dp);\r\n}\r\n\r\n.bg-5dp {\r\n\tbackground: var(--bg-primary-5dp);\r\n}\r\n\r\n.bg-8dp {\r\n\tbackground: var(--bg-primary-8dp);\r\n}\r\n\r\n.bg-12dp {\r\n\tbackground: var(--bg-primary-12dp);\r\n}\r\n\r\n.bg-24dp {\r\n\tbackground: var(--bg-primary-24dp);\r\n}\r\n\r\n.border-24dp {\r\n\tborder-color: var(--color-primary-24dp) !important;\r\n\topacity: 1;\r\n}\r\n\r\n.border-start-4 {\r\n\tborder-left-width: 4px !important; \r\n}\r\n\r\n.btn {\r\n\talign-items: center;\r\n\tborder: none;\r\n\t/* display: flex; */ /* Dave: occhio, il display flex rompe tutti i bottoni, chiedere a Dave*/\r\n}\r\n\r\n/* change in small */\r\n.btn, \r\n.dropdown-menu-container, \r\n.swap-background-checkbox > input[type=checkbox].form-check-input ~ label, \r\n.swap-background-checkbox > input[type=radio].form-check-input ~ label, \r\n.form-control, \r\n.form-control-plaintext, \r\n.form-select, \r\n/* .input-group input, */\r\n.input-group-text {\r\n\tborder: none;\r\n\tborder-radius: 0.375rem;\r\n\tline-height: 1.5em;\r\n\tpadding: .25rem .5rem;\r\n} \r\n\r\n.btn:hover.dropdown-toggle {\r\n\tborder: 2px solid var(--color-primary-30dp);\r\n}\r\n\r\n.btn.active {\r\n\tcolor: var(--text-primary-high-emp);\r\n \tbackground: var(--bg-primary-24dp);\r\n}\r\n\r\n.btn.disabled, \r\n.disabled {\r\n\topacity: .3;\r\n\tpointer-events: none;\r\n}\r\n\r\n.btn-dark {\r\n \t--bs-btn-color: #fff;\r\n \t--bs-btn-bg: var(--color-primary-24dp);\r\n \t--bs-btn-border-color: var(--color-primary-24dp);\r\n \t--bs-btn-hover-color: #fff;\r\n \t--bs-btn-hover-bg: #424649;\r\n \t--bs-btn-hover-border-color: #373b3e;\r\n \t--bs-btn-focus-shadow-rgb: 66,70,73;\r\n \t--bs-btn-active-color: #fff;\r\n \t--bs-btn-active-bg: #4d5154;\r\n \t--bs-btn-active-border-color: #373b3e;\r\n \t--bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\r\n \t--bs-btn-disabled-color: #fff;\r\n \t--bs-btn-disabled-bg: #212529;\r\n \t--bs-btn-disabled-border-color: #212529;\r\n}\r\n\r\n.btn-circle {\r\n\taspect-ratio: 1;\r\n\tjustify-content: center;\r\n\tline-height: 0;\r\n\twidth: 2.5em;\r\n}\r\n\r\n.btn-circle-sm {\r\n\tfont-size: 0.7rem;\r\n\theight: 1.5rem;\r\n \tpadding: unset;\r\n\twidth: 1.5rem;\r\n}\r\n\r\n.btn-light {\r\n\tbackground: none;\r\n}\r\n\r\n.btn-light,\r\n.btn-light:hover,\r\n.btn-check+.btn:hover {\r\n\tcolor: var(--text-primary-medium-emp); \r\n}\r\n\r\n.btn-light:active, \r\n.btn-check:checked+.btn {\r\n\tcolor: var(--text-primary-high-emp); \r\n}\r\n\r\n.btn-light:active, \r\n.btn-light:hover, \r\n.btn-check+.btn:hover, \r\n.btn-check:checked+.btn {\r\n\tbackground: var(--bg-primary-24dp);\r\n}\r\n\r\n.btn-link {\r\n\t--bs-btn-color: hsl(var(--brand-hue), var(--brand-saturation), calc(var(--brand-lightness) + 5%));\r\n\t--bs-btn-hover-color: var(--brand);\r\n\t--bs-btn-active-color: var(--brand);\r\n}\r\n\r\n\r\n#signView .btn-link {\r\n\t--bs-btn-color: var(--bs-secondary);\r\n\t--bs-btn-hover-color: hsl(var(--bs-secondary-hue), var(--bs-secondary-saturation), calc(var(--bs-secondary-lightness) + 5%));\r\n\t--bs-btn-active-color: hsl(var(--bs-secondary-hue), var(--bs-secondary-saturation), calc(var(--bs-secondary-lightness) + 5%));\r\n}\r\n\r\n.btn-primary {\r\n \t--bs-btn-color: #fff;\r\n \t--bs-btn-bg: var(--brand);\r\n \t--bs-btn-border-color: var(--brand);\r\n \t--bs-btn-hover-color: #fff;\r\n \t--bs-btn-hover-bg: hsl(var(--brand-hue), var(--brand-saturation), calc(var(--brand-lightness) + 5%)); \r\n \t--bs-btn-hover-border-color: hsl(var(--brand-hue), var(--brand-saturation), calc(var(--brand-lightness) + 5%)); \r\n \t--bs-btn-focus-shadow-rgb: 49,132,253;\r\n \t--bs-btn-active-color: #fff;\r\n \t--bs-btn-active-bg: hsl(var(--brand-hue), var(--brand-saturation), calc(var(--brand-lightness) + 10%));\r\n \t--bs-btn-active-border-color: hsl(var(--brand-hue), var(--brand-saturation), calc(var(--brand-lightness) + 10%));\r\n \t--bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\r\n \t--bs-btn-disabled-color: #fff;\r\n \t--bs-btn-disabled-bg: hsl(var(--brand-hue), var(--brand-saturation), calc(var(--brand-lightness) - 5%));\r\n \t--bs-btn-disabled-border-color: hsl(var(--brand-hue), var(--brand-saturation), calc(var(--brand-lightness) - 5%));\r\n}\r\n\r\n/* .btn-primary, \r\n.btn-primary.disabled { \r\n\tbackground-color: var(--brand);\r\n} */\r\n\r\n.btn-primary.active {\r\n\tbackground: var(--brand);\r\n}\r\n\r\n.btn-pwsm {\r\n\tbackground: #666666;\r\n\tborder: 1px solid #000000;\r\n\tcolor: #eeeeee;\r\n\toutline: none;\r\n}\r\n\r\n.btn-pwsm:focus, \r\n.btn-pwsm:hover, \r\n.btn-pwsm:active:focus {\r\n\tbackground: #607D8B;\r\n\tcolor: #e2e2e2;\r\n\toutline: none;\r\n}\r\n\r\n.btn-secondary {\r\n\t--bs-btn-color: #fff;\r\n\t--bs-btn-bg: var(--bs-secondary);\r\n \t--bs-btn-border-color: #6c757d;\r\n \t--bs-btn-hover-color: #fff;\r\n \t--bs-btn-hover-bg: hsl(var(--bs-secondary-hue), var(--bs-secondary-saturation), calc(var(--bs-secondary-lightness) + 5%)); \r\n \t--bs-btn-hover-border-color: hsl(var(--bs-secondary-hue), var(--bs-secondary-saturation), calc(var(--bs-secondary-lightness) + 5%)); \r\n \t--bs-btn-focus-shadow-rgb: 130,138,145;\r\n \t--bs-btn-active-color: #fff;\r\n \t--bs-btn-active-bg: hsl(var(--bs-secondary-hue), var(--bs-secondary-saturation), calc(var(--bs-secondary-lightness) + 10%));\r\n \t--bs-btn-active-border-color: hsl(var(--bs-secondary-hue), var(--bs-secondary-saturation), calc(var(--bs-secondary-lightness) + 10%));\r\n \t--bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\r\n \t--bs-btn-disabled-color: #fff;\r\n\t--bs-btn-disabled-bg: hsl(var(--bs-secondary-hue), var(--bs-secondary-saturation), calc(var(--bs-secondary-lightness) - 5%));\r\n \t--bs-btn-disabled-border-color: hsl(var(--bs-secondary-hue), var(--bs-secondary-saturation), calc(var(--bs-secondary-lightness) - 5%));\r\n}\r\n\r\n/* .col, .col-1, .col-10, .col-11, .col-12, .col-2, .col-3, .col-4, .col-5, .col-6, .col-7, .col-8, .col-9, .col-auto, .col-lg, .col-lg-1, .col-lg-10, .col-lg-11, .col-lg-12, .col-lg-2, .col-lg-3, .col-lg-4, .col-lg-5, .col-lg-6, .col-lg-7, .col-lg-8, .col-lg-9, .col-lg-auto, .col-md, .col-md-1, .col-md-10, .col-md-11, .col-md-12, .col-md-2, .col-md-3, .col-md-4, .col-md-5, .col-md-6, .col-md-7, .col-md-8, .col-md-9, .col-md-auto, .col-sm, .col-sm-1, .col-sm-10, .col-sm-11, .col-sm-12, .col-sm-2, .col-sm-3, .col-sm-4, .col-sm-5, .col-sm-6, .col-sm-7, .col-sm-8, .col-sm-9, .col-sm-auto, .col-xl, .col-xl-1, .col-xl-10, .col-xl-11, .col-xl-12, .col-xl-2, .col-xl-3, .col-xl-4, .col-xl-5, .col-xl-6, .col-xl-7, .col-xl-8, .col-xl-9, .col-xl-auto {\r\n\tpadding-left: 5px;\r\n\tpadding-right: 5px;\r\n} */\r\n\r\n.cursor-pointer {\r\n\tcursor: pointer;\r\n}\r\n\r\n.dropdown .dropdown-item {\r\n\tcolor: var(--text-primary-low-emp);\r\n}\r\n\r\n.dropdown .dropdown-item:hover {\r\n\tbackground-color: var(--bg-primary-24dp);\r\n}\r\n\r\n.dropdown .dropdown-item:hover, \r\n.dropdown .dropdown-toggle:active, \r\n.dropdown .dropdown-toggle.show {\r\n\tcolor: var(--text-primary-high-emp);\r\n}\r\n\r\n.dropdown.form-control .dropdown-toggle {\r\n\tborder: none;\r\n}\r\n\r\n.dropdown .dropdown-toggle, \r\n.form-select {\r\n\tcolor: var(--text-primary-medium-emp);\r\n \twidth: 100%;\r\n}\r\n\r\n.dropdown-toggle::after {\r\n\tmargin-left: auto;\r\n}\r\n\r\n.dropdown-menu {\r\n\tbackground: var(--color-primary-24dp);\r\n\tmargin: .5rem !important; /* ALICE: deve contrastare stile in linea */\r\n\tmax-height: 50vh;\r\n\tmin-width: 100%;\r\n \toverflow: auto;\r\n}\r\n\r\n.dropdown-menu-container {\r\n\tdisplay: none;\r\n\tbackground: var(--bg-primary-8dp);\r\n}\r\n\r\n.dropdown-menu-container.show {\r\n\tdisplay: flex;\r\n\tflex-direction: column;\r\n}\r\n\r\n.dropdown-menu-container .dropdown-item:hover {\r\n\tbackground: var(--bg-primary-12dp);\r\n}\r\n\r\n/* .form-inline .form-control {\r\n\twidth: 100%;\r\n} */\r\n\r\n.form-control:focus {\r\n \tborder-color: var(--brand);\r\n}\r\n\r\n.fs-7 {\r\n\tfont-size: 0.75rem;\r\n}\r\n\r\n.fs-8 {\r\n\tfont-size: 0.5rem;\r\n}\r\n\r\n.client-field {\r\n\tfont-size: 1.1rem;\r\n}\r\n\r\n.color-palette{\r\n\tdisplay: grid; \r\n\tgap: .5em; \r\n\tgrid-template-columns: 1fr 1fr 1fr;\r\n}\r\n\r\n.custom-checkbox {\r\n\tpadding-left: 0;\r\n}\r\n\r\n.custom-checkbox > input[type=checkbox].form-check-input,\r\n.custom-checkbox > input[type=radio].form-check-input {\r\n\tdisplay: none;\r\n}\r\n\r\n.form-box {\r\n\talign-items: center;\r\n\tbackground: var(--bg-primary-8dp);\r\n\tborder-radius: .375rem;\r\n\tdisplay: flex;\r\n\theight: 100%;\r\n\tisolation: isolate;\r\n\tjustify-content: center;\r\n\tleft: 0;\r\n\toverflow: hidden;\r\n\tposition: absolute;\r\n\ttop: 0px;\r\n\ttransition: .5s ease-in-out;\r\n\twidth: 100%;\r\n}\r\n\r\n.form-box form {\r\n\tleft: 0;\r\n\tpadding: 0 10%;\r\n\tposition: absolute;\r\n\ttransition: .5s;\r\n\twidth: 100%;\r\n}\r\n\r\n.form-box .signinForm {\r\n\ttransition-delay: .25s;\r\n}\r\n\r\n.form-box .signupForm {\r\n\tleft: 100%;\r\n\ttransition-delay: 0s;\r\n}\r\n\r\n.form-check-input:checked {\r\n \tbackground-color: var(--bs-secondary);\r\n \tborder-color: var(--bs-secondary);\r\n}\r\n\r\n.form-check-input:focus {\r\n\tborder-color: hsl(var(--bs-secondary-hue), var(--bs-secondary-saturation), calc(var(--bs-secondary-lightness) + 15%));\r\n \toutline: 0;\r\n \tbox-shadow: 0 0 0 0.25rem rgba(var(--bs-secondary-rgb), 25%);\r\n}\r\n\r\n.form-control,\r\n.form-control-plaintext {\r\n\tcolor: var(--text-primary-medium-emp);\r\n}\r\n\r\n.form-control { \t\r\n\tbackground: none;\r\n}\r\n\r\n.form-control-plaintext {\r\n\tbackground: var(--bg-primary-24dp);\r\n}\r\n\r\n.form-control-plaintext {\r\n\tborder: 2px solid transparent;\r\n}\r\n\r\n/* input[type=search].form-control, */\r\n/* .dropdown .dropdown-toggle, */\r\n.dropdown-toggle, \r\n.dropdown .dropdown-menu,\r\n.dropdown-menu, \r\n.dropdown .dropdown-menu.show,\r\n.form-control, \r\n.form-select,\r\n.search-group > * {\r\n\tborder: 2px solid var(--color-primary-24dp);\r\n}\r\n\r\n.form-control:focus {\r\n\tbackground-color: transparent;\r\n\tcolor: var(--text-primary-medium-emp);\r\n\tbox-shadow: none;\r\n}\r\n\r\n.form-group label {\r\n\tcolor: var(--text-primary-high-emp);\r\n\tfont-weight: 500;\r\n}\r\n\r\n.form-select {\r\n\tbackground-color: transparent;\r\n\t/* background-color: var(--color-primary-24dp); */\r\n\tbackground-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3e%3cpath fill='none' stroke='%23ffffff' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='m2 5 6 6 6-6'/%3e%3c/svg%3e\");\r\n}\r\n\r\n.form-select:focus {\r\n\tborder: 2px solid var(--brand);\r\n\tbox-shadow: none;\r\n}\r\n\r\n/* .form-switch label {\r\n\tvertical-align: -4px;\r\n} */\r\n\r\n.form-switch .form-check-input:focus {\r\n \tbackground-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'%3e%3ccircle r='3' fill='%23A570FA'/%3e%3c/svg%3e\");\r\n}\r\n.form-switch .form-check-input:checked {\r\n \tbackground-position: right center;\r\n \tbackground-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'%3e%3ccircle r='3' fill='%23fff'/%3e%3c/svg%3e\");\r\n}\r\n\r\n.formTray.closed {\r\n\tdisplay: none;\r\n}\r\n\r\n.icon-admin, \r\n.icon-powerAdmin {\r\n\tcolor: var(--bs-danger);\r\n}\r\n\r\n.icon-owner {\r\n\tcolor: var(--bs-warning);\r\n}\r\n\r\n.icon-user,\r\n.icon-powerUser {\r\n\tcolor: var(--bs-success);\r\n}\r\n\r\n.icon-play {\r\n\tpadding-left: 0.2rem; /*Alice: correzione ottica*/\r\n}\r\n\r\n.icon-pencil.rounded-circle {\r\n\tpadding: 0.75em;\r\n \tfont-size: 0.6rem;\r\n}\r\n\r\n.input-group-text {\r\n\tbackground: var(--bg-primary-24dp);\r\n\tcolor: var(--text-primary-high-emp);\r\n}\r\n\r\n.btn:has(.invalid),\r\n.invalid {\r\n\tborder: 2px solid var(--bs-danger);\r\n\tanimation: shake 0.2s 2;\r\n}\r\n\r\n@keyframes shake {\r\n\t25% {\r\n\t\ttranslate: 6px 0;\r\n\t}\r\n\t50% {\r\n\t\ttranslate: -6px 0;\r\n\t}\r\n\t75% {\r\n\t\ttranslate: 6px 0;\r\n\t}\r\n}\r\n\r\n.item-list-box {\r\n\theight: 45vh;\r\n\toverflow: hidden; /* Dave: Questi servono, verificare con lunga lista progetti e lunga lista task*/\r\n\toverflow-y: auto; /* Dave: Questi servono, verificare con lunga lista progetti e lunga lista task*/\r\n}\r\n\r\n.list-group-item {\r\n\tpadding: .7rem .25rem;\r\n}\r\n\r\n.locked {\r\n\topacity: .5;\r\n \tpointer-events: none;\r\n}\r\n\r\n.manualDtEndBox > *, \r\n.manualDtStartBox > * {\r\n\tdisplay: inline-block;\r\n\tvertical-align: middle;\r\n}\r\n\r\n.manualDtEndBox > input, \r\n.manualDtStartBox > input, \r\n#taskListBox, \r\n#adminSelector, \r\n#projectListBox {\r\n\tcolor: #333333;\r\n}\r\n\r\n.ml-auto {\r\n\tmargin-left: auto !important;\r\n}\r\n\r\n.modal-footer, \r\n.modal-header {\r\n\tborder: none;\r\n}\r\n \r\n.mt-7 {\r\n\tmargin-top: 4rem;\r\n}\r\n\r\n.nav-link {\r\n\tcursor: pointer;\r\n}\r\n\r\n.nav-tabs .nav-link {\r\n\tborder: none;\r\n}\r\n\r\n.nav-link:focus, .nav-link:hover {\r\n\tcolor: var(--text-primary-high-emp);\r\n}\r\n\r\n.nav-tabs .nav-link.active {\r\n\tbackground-color: var(--text-primary-high-emp);\r\n\tcolor: var(--bg-primary);\r\n}\r\n\r\n.navbar {\r\n\tpadding: .2rem 1rem;\r\n}\r\n\r\n.navbar-toggler-icon {\r\n\theight: 1.2em;\r\n\twidth: 1.2em;\r\n}\r\n\r\n.nav-lateral-logo-icon {\r\n\twidth: 2rem;\r\n}\r\n\r\n.nav-logo-icon {\r\n\twidth: 1.2rem;\r\n}\r\n\r\n.nav-link {\r\n\tcolor: var(--text-primary-high-emp);\r\n}\r\n\r\n.nav-menu {\r\n\tborder-radius: 0 0.375rem 0.375rem 0;\r\n\theight: fit-content;\r\n\tmargin-top: .5rem;\r\n}\r\n\r\n.nav-menu.open {\r\n\theight: auto;\r\n\tmargin-top: 0;\r\n}\r\n\r\n.nav-tabs .nav-link.active {\r\n\tbackground-color: var(--text-primary-high-emp);\r\n}\r\n\r\n.offcanvas-body {\r\n\toverflow: unset;\r\n}\r\n\r\n.organization-ref::before {\r\n\t/* background-color: white; */\r\n\tcontent: \"\";\r\n\tdisplay: block;\r\n\theight: 100%;\r\n\tleft: 1rem;\r\n\tposition: absolute;\r\n\ttop: 0;\r\n\twidth: 5px;\r\n}\r\n\r\n.organization-ref-start-0::before {\r\n\tleft: 0;\r\n}\r\n\r\n.profile-image {\r\n\theight: auto;\r\n\twidth: 10rem;\r\n}\r\n\r\n.profile-image, \r\n.profile-image-sm {\r\n\taspect-ratio: 1; \r\n}\r\n\r\nimg.profile-image {\r\n\taspect-ratio: 1; \r\n\tborder-radius: 50%;\r\n\tobject-fit: cover;\r\n}\r\n\r\n.profile-image-sm {\r\n\tobject-fit: cover; \r\n\twidth: 1.5rem;\r\n}\r\n\r\n.profile-image-edit {\r\n\tposition: relative;\r\n\ttransition: opacity .2s ease-in-out;\r\n}\r\n\r\n.profile-image-edit:hover .profile-image {\r\n\topacity: .5;\r\n}\r\n\r\n.profile-image-edit:hover .profile-image-edit-content {\r\n\topacity: 1;\r\n}\r\n\r\n.profile-image-edit a.dropdown-toggle {\r\n\ttext-decoration: none;\r\n}\r\n\r\n.profile-image-edit a.dropdown-toggle::after {\r\n\tdisplay: none;\r\n}\r\n\r\n/* Alice: non sapevo come altro selezionarla */\r\n.profile-image-edit div.dropdown-menu-container {\r\n \tleft: 50%;\r\n \tposition: absolute;\r\n \ttop: 50%;\r\n}\r\n\r\n.profile-image-edit-content {\r\n\tposition: absolute;\r\n\ttop: 0;\r\n\tright: 0;\r\n\tbottom: 0;\r\n\tleft: 0;\r\n\tdisplay: flex;\r\n\tflex-direction: column;\r\n\tjustify-content: center;\r\n\talign-items: center;\r\n\tcolor: white;\r\n\topacity: 0;\r\n\ttransition: opacity .2s ease-in-out;\r\n}\r\n\r\n.profile-image-edit-content .icon-pencil {\r\n\tfont-size: 2.5rem;\r\n}\r\n\r\n.profile-default-icon {\r\n\tfont-size: 4rem;\r\n}\r\n\r\n.profile-default-icon, \r\n.profile-default-icon-sm { \r\n\talign-items: center;\r\n\taspect-ratio: 1;\r\n \tbackground: var(--brand);\r\n \tborder-radius: 50%;\r\n \tdisplay: flex;\r\n\tfont-weight: bold;\r\n \tjustify-content: center;\r\n \tline-height: 1em;\r\n\ttext-align: center;\r\n}\r\n\r\n.profile-default-icon-sm {\r\n\tfont-size: 0.7rem;\r\n \theight: calc(1.275rem + 0.3vw);\r\n\tpadding: 0.3em;\r\n}\r\n\r\n.ps-45 {\r\n\tpadding-left: 2rem;\r\n}\r\n\r\n.row {\r\n\tmargin: 0;\r\n}\r\n\r\n.search-group > * {\r\n\tbackground: var(--bg-primary-24dp);\r\n\tcolor: var(--text-primary-low-emp);\r\n}\r\n\r\n.search-group.active-filter > * {\r\n\tbackground: var(--bs-warning);\r\n\tborder: 2px solid var(--bs-warning);\r\n\tcolor: var(--bg-primary);\r\n}\r\n\r\n/* .search-group.active-filter input[type=search].form-control {\r\n\tborder: none;\r\n} */\r\n\r\n.scrollbar-hidden {\r\n\t-ms-overflow-style: none;\r\n\tscrollbar-width: none; /* Firefox */\r\n}\r\n\r\n.scrollbar-hidden::-webkit-scrollbar {\r\n\tdisplay: none;\r\n}\r\n\r\n.sign-box {\r\n\tisolation: isolate;\r\n\theight: 150px;\r\n}\r\n\r\n.sign-container {\r\n\tposition: relative;\r\n}\r\n\r\n.sign-container > * {\r\n\theight: 360px;\r\n}\r\n\r\n.sign-view.up-active .sign-container > * {\r\n\theight: 650px;\r\n}\r\n\r\n.sign-container .row [class^=\"col-\"] {\r\n\tbackground: hsla(0, 0%, 100%, .2);\r\n\tbox-shadow: 0 5px 45px hsla(0, 0%, 0%, .15);\r\n}\r\n\r\n.sign-container .row div:first-of-type{\r\n\tborder-radius: .375rem .375rem 0 0;\r\n}\r\n\r\n.sign-container .row div:last-of-type{\r\n\tborder-radius: 0 0 .375rem .375rem;\r\n}\r\n\r\n.sign-view {\r\n\talign-items: center;\r\n\tbackground: var(--bg-primary);\r\n\theight: 100%;\r\n\tmin-height: 100vh;\r\n\t/* padding-top: 5em; */\r\n\ttext-align: center;\r\n\ttransition: .5s;\r\n}\r\n\r\n.sign-view .signup {\r\n\tmargin-top: 210px;\r\n}\r\n\r\n.sign-view.up-active {\r\n\tbackground: var(--brand);\r\n}\r\n\r\n.sign-view.up-active .form-box {\r\n\tleft: 0;\r\n\ttop: 150px;\r\n}\r\n\r\n.sign-view .sign-box.signin {\r\n \tmargin-top: 20px;\r\n}\r\n\r\n.sign-view.up-active .form-box .signinForm {\r\n\tleft: -100%;\r\n\ttransition-delay: 0s;\r\n}\r\n\r\n.sign-view.up-active .form-box .signupForm {\r\n\tleft: 0;\r\n\ttransition-delay: .25s;\r\n}\r\n\r\n.sign-view.up-active .signup {\r\n\tmargin-top: 0;\r\n}\r\n\r\n\r\n.singleClient {\r\n\tborder-bottom: var(--bs-border-width) solid rgba(var(--client-rgb), .2);\r\n}\r\n\r\n[id^=\"sessionList_\"] .singleSession {\r\n \tborder-bottom: var(--bs-border-width) solid rgba(var(--ws-rgb), .2);\r\n}\r\n\r\n[id^=\"client_\"] .singleProject {\r\n \tborder-bottom: var(--bs-border-width) solid rgba(var(--project-rgb), .2);\r\n}\r\n\r\n[id^=\"prj_\"] .singleTask {\r\n \tborder-bottom: var(--bs-border-width) solid rgba(var(--task-rgb), .2);\r\n}\r\n\r\n.singleClient .row, \r\n[id^=\"sessionList_\"] .singleSession .row, \r\n[id^=\"client_\"] .singleProject .row, \r\n[id^=\"prj_\"] .singleTask {\r\n\talign-items: center;\r\n}\r\n\r\n.single-table-row {\r\n\tdisplay: none !important;\r\n}\r\n\r\n.single-table-row.render {\r\n\tdisplay: block !important;\r\n}\r\n\r\n.singleTask {\r\n\tdisplay: none !important;\r\n\t/* padding: .3rem; */\r\n}\r\n\r\n.singleTask.render {\r\n\tdisplay: block !important;\r\n}\r\n\r\n/* Dave:Schifo */\r\n.singleStatsTask.render {\r\n\tdisplay: flex !important;\r\n}\r\n\r\n.spinner-lg {\r\n\tfont-size: 2em;\r\n\theight: 3em;\r\n\twidth: 3em;\r\n}\r\n\r\n.swap-icon-checkbox > input[type=checkbox].form-check-input ~ label::before {\r\n \tfont-family: 'timecorder' !important;\r\n \tspeak: never;\r\n \tfont-style: normal;\r\n \tfont-weight: normal;\r\n \tfont-variant: normal;\r\n \ttext-transform: none;\r\n \tline-height: 1;\r\n\r\n \t/* Better Font Rendering =========== */\r\n \t-webkit-font-smoothing: antialiased;\r\n \t-moz-osx-font-smoothing: grayscale;\r\n\r\n\tmargin-right: .5rem;\r\n}\r\n\r\n.swap-icon-checkbox.permission-checkbox > input[type=checkbox].form-check-input ~ label::before {\r\n\tcolor: var(--bs-danger);\r\n\tcontent: \"\\e93d\";\r\n\tfont-size: 1.2rem;\r\n} \r\n\r\n.swap-icon-checkbox.permission-checkbox > input[type=checkbox].form-check-input:checked ~ label::before {\r\n\tcolor: var(--bs-success);\r\n\tcontent: \"\\e941\";\r\n} \r\n\r\n.swap-icon-checkbox.visibility-checkbox > input[type=checkbox].form-check-input ~ label::before{\r\n\tcontent: \"\\e940\"; \r\n} \r\n\r\n.swap-icon-checkbox.visibility-checkbox > input[type=checkbox].form-check-input:checked ~ label::before{\r\n\tcontent: \"\\e942\"; \r\n} \r\n\r\n.swap-background-checkbox > input[type=checkbox].form-check-input ~ label,\r\n.swap-background-checkbox > input[type=radio].form-check-input ~ label {\r\n\tdisplay: block;\r\n}\r\n\r\n.swap-background-checkbox > input[type=checkbox].form-check-input:checked ~ label,\r\n.swap-background-checkbox > input[type=radio].form-check-input:checked ~ label {\r\n\tbackground: var(--bg-primary-30dp);\r\n\tcolor: var(--text-primary-high-emp);\r\n}\r\n\r\n.table-row {\r\n\tborder-bottom: 1px solid var(--color-primary-8dp);\r\n\tposition: relative;\r\n}\r\n\r\n.table-row.active,\r\n.selected {\r\n \tbackground-color: rgba(var(--brand-rgb), .3);\r\n}\r\n\r\n.table-row:first-of-type {\r\n\tborder-top-style: solid;\r\n\tborder-top-width: 1px;\r\n\tborder-top-color: var(--color-primary-8dp);\r\n}\r\n\r\n.table-row.single-table-row {\r\n\tpadding: .5rem 1rem .5rem calc(1.5rem + 5px);\r\n}\r\n\r\n.tabular-nums {\r\n\tfont-variant: tabular-nums;\r\n}\r\n\r\n.text-color-2 {\r\n\tcolor: var(--color-2);\r\n}\r\n\r\n.text-color-3 {\r\n\tcolor: var(--color-3);\r\n}\r\n\r\n.text-color-4 {\r\n\tcolor: var(--color-4);\r\n}\r\n\r\n.text-color-5 {\r\n\tcolor: var(--color-5);\r\n}\r\n\r\n.text-color-6 {\r\n\tcolor: var(--color-6);\r\n}\r\n\r\n.text-color-7 {\r\n\tcolor: var(--color-7);\r\n}\r\n\r\n.text-color-8 {\r\n\tcolor: var(--color-8);\r\n}\r\n\r\n.text-color-9 {\r\n\tcolor: var(--color-9);\r\n}\r\n\r\n.text-color-10 {\r\n\tcolor: var(--color-10);\r\n}\r\n\r\n.text-color-11 {\r\n\tcolor: var(--color-11);\r\n}\r\n\r\n.text-color-12 {\r\n\tcolor: var(--color-12);\r\n}\r\n\r\n.text-danger {\r\n\tcolor: var(--bs-danger) !important;\r\n}\r\n\r\n.text-primary {\r\n\tcolor: var(--brand) !important;\r\n}\r\n\r\n.text-secondary {\r\n\tcolor: var(--bs-secondary) !important;\r\n}\r\n\r\n.text-warning {\r\n\tcolor: var(--bs-warning) !important;\r\n} \r\n\r\n.text-high-emp {\r\n\tcolor: var(--text-primary-high-emp);\r\n}\r\n\r\n.text-low-emp {\r\n\tcolor: var(--text-primary-low-emp);\r\n}\r\n\r\n.text-medium-emp {\r\n\tcolor: var(--text-primary-medium-emp);\r\n}\r\n\r\n.text-client {\r\n\tcolor: var(--client);\r\n}\r\n\r\n.text-project {\r\n\tcolor: var(--project);\r\n}\r\n\r\n.text-task {\r\n\tcolor: var(--task);\r\n}\r\n\r\n.text-ws {\r\n\tcolor: var(--ws);\r\n}\r\n\r\n/* .topBtnBox > * {\r\n\tdisplay: inline-block;\r\n\tmargin-bottom: 5px!important;\r\n\tvertical-align: middle;\r\n} */\r\n\r\n.to-hover:hover .to-show {\r\n\tdisplay: block; \r\n}\r\n\r\n.to-show {\r\n\tdisplay: block;\r\n}\r\n\r\n.user-dropdown {\r\n\tmax-height: calc(((1.5rem + 0.5rem + .125rem + (var(--bs-dropdown-item-padding-y) * 2)) * 12) + 1rem);\r\n\t/* overflow: scroll; Alice.Warn: \"scroll\" significa forza lo scroll sia che serva sia che non serva, quindi compare la scrollbar anche in orizontale*/\r\n\toverflow: auto;/* ...\"auto\", invece, signica \"mostra le scrollbar solo se servono, solo dove servono\" */\r\n}\r\n\r\n.wait-box-local {\r\n\talign-items: center;\r\n\tbackground-color: rgba(128, 128, 128, .6);\r\n\tbottom: 0;\r\n\tdisplay: flex;\r\n\tjustify-content: center;\r\n\tleft: 0;\r\n\tpointer-events: none;\r\n\tposition: absolute;\r\n\tright: 0;\r\n\ttop: 0;\r\n\tz-index: 99;\r\n}\r\n\r\n.w-fit-content {\r\n\twidth: fit-content;\r\n}\r\n\r\n.w-max-content {\r\n\twidth: max-content;\r\n}\r\n\r\n#adminSelectorBox {\r\n\tmargin-bottom: 20px;\r\n}\r\n\r\n#adminSelectorBox .input-group-addon {\r\n \tbackground: #666666;\r\n \tcolor: #e2e2e2;\r\n \toutline: none;\r\n}\r\n\r\n#autoSaveTimeOutBar {\r\n\tbackground-color: #398439;\r\n\tbottom: 0;\r\n\tdisplay: none;\r\n\theight: 4px;\r\n\tmargin: 0 5px;\r\n\tposition: absolute;\r\n\tright: 5px;\r\n\ttransition: none;\r\n\twidth: calc(100% - 10px);\r\n}\r\n\r\n#autoSaveTimeOutBar.running {\r\n\tbackground-color: #e95317;\r\n\ttransition: all 3s linear;\r\n\twidth: 0%;\r\n}\r\n\r\n#burgerBtn {\r\n\tz-index: 1050;\r\n}\r\n\r\n.collapsed #elapsedTimeCollapsed {\r\n\tdisplay: block;\r\n}\r\n\r\n/* #filterRangeDateBox {\r\n\twidth: 300px;\r\n} */\r\n\r\n/* #filterUserBox {\r\n\twidth: 200px;\r\n} */\r\n\r\n#filterUserField {\r\n\tborder-left-color: #343a40;\r\n}\r\n\r\n#loginForm .has-error {\r\n\tbackground-color: #f2dede;\r\n\tborder-color: #a94442;\r\n\t-webkit-box-shadow: inset 0 1px 1px rgba(0, 0, 0, .075);\r\n\tbox-shadow: inset 0 1px 1px rgba(0, 0, 0, .075);\r\n}\r\n\r\n#logOutBtn {\r\n\tmargin: 0;\r\n}\r\n\r\n/* #newProjectTray, */\r\n#newTaskTray, \r\n#projectPermissionTray,\r\n#taskPermissionTray {\r\n\tbackground-color: #333333;\r\n\tborder-radius: 0 0 10px 10px;\r\n\tbox-shadow: 3px 7px 10px rgba(0, 0, 0, 0.5);\r\n\tleft: 5px;\r\n\tpadding: 10px;\r\n\tposition: absolute;\r\n\tright: 5px;\r\n\ttop: 67px;\r\n\tz-index: 99;\r\n}\r\n\r\n#statsContainer:has(.reportTab) #filterColumn {\r\n\tdisplay: none;\r\n}\r\n\r\n#statsContainer:has(.reportTab.active) #filterColumn {\r\n\tdisplay: flex;\r\n}\r\n\r\n#taskListBox, \r\n#projectListBox {\r\n\t/*border: 1px solid #000000;*/\r\n\tborder-radius: 5px 0 0 5px;\r\n\tmargin-bottom: 15px;\r\n}\r\n\r\n#taskListBox ul, \r\n#projectListBox ul {\r\n\theight: 100%;\r\n\toverflow: hidden;\r\n \toverflow-y: auto;\r\n}\r\n\r\n#taskListBox > .list-group, \r\n#projectListBox > .list-group {\r\n\t/* height: 100%; */\r\n\tmargin-bottom: 0;\r\n}\r\n\r\n#taskListBox > .list-group li, \r\n#projectListBox > .list-group li {\r\n\tborder-radius: 0;\r\n\t/* cursor: pointer; */\r\n\t/* font-size: .7rem; */\r\n\tline-height: 1.2em;\r\n\twhite-space: nowrap;\r\n}\r\n\r\n#projectContextMenu, \r\n#taskContextMenu {\r\n\tposition: fixed;\r\n}\r\n\r\n/* #projectListBox > .list-group > li * {\r\n\tpointer-events: none;\r\n} */\r\n\r\n#searchBox {\r\n\twidth: 250px;\r\n}\r\n\r\n#serverPathBox {\r\n \tmargin-bottom: 20px;\r\n}\r\n\r\n#serverPathBox > div {\r\n \tmargin-bottom: 0;\r\n}\r\n\r\n#wait-box {\r\n \talign-items: center;\r\n\tbackground-color: rgba(255, 255, 255, .7);\r\n\tbottom: 0;\r\n \tdisplay: flex;\r\n \tflex-direction: column;\r\n \tjustify-content: center;\r\n\tleft: 0;\r\n\tposition: fixed;\r\n\tright: 0;\r\n\ttop: 0;\r\n\tz-index: 99999999;\r\n}\r\n/* TODO: ragionarci sopra \r\n.container-filters, \r\n.container-sort {\r\n\tcontainer-type: inline-size;\r\n\tcontainer-name: sort;\r\n}\r\n\r\n.container-filters .filter-label, \r\n.container-filters .filter-title, \r\n.container-sort .sort-label, \r\n.container-sort .sort-title {\r\n\tdisplay: none;\r\n}\r\n\r\n.container-filters .filter-icon, \r\n.container-sort .sort-icon {\r\n\tdisplay: inline;\r\n}\r\n\r\n@container (min-width: 300px){\t\r\n\t.container-sort .sort-title {\r\n\t\tdisplay: inline;\r\n\t}\r\n\t.container-filter .filter-title {\r\n\t\tdisplay: inline;\r\n\t}\r\n\t.container-filter .filter-title {\r\n\t\tdisplay: inline;\r\n\t}\r\n}\r\n\r\n@container (min-width: 400px){\t\r\n\t.container-sort .sort-title {\r\n\t\tdisplay: none;\r\n\t}\r\n}\r\n\r\n@container (min-width: 450px){\t\r\n\t.container-filters .filter-label {\r\n\t\tdisplay: inline;\r\n\t}\r\n\r\n\t.container-filters .filter-title {\r\n\t\tdisplay: none;\r\n\t}\r\n}\r\n\r\n@container (min-width: 500px){\t\r\n\t.container-sort .sort-label {\r\n\t\tdisplay: inline;\r\n\t}\r\n\t.container-sort .sort-title {\r\n\t\tdisplay: inline;\r\n\t}\r\n\t.container-filters .filter-title {\r\n\t\tdisplay: inline;\r\n\t}\r\n} \r\n*/\r\n\r\n@media (min-width: 576px) { \r\n\t.w-sm-auto {\r\n\t\twidth: auto !important;\r\n\t}\r\n}\r\n\r\n@media (min-width: 768px) { \r\n\tbody.isRunningWorkSession {\r\n\t\tpadding-bottom: calc(1.5rem + 1.5rem + 1rem + ((1rem + 1.5rem) * 3) + 1.5rem);\r\n\t}\r\n\r\n\tbody[data-page-id=\"signView\"] {\r\n\t\tpadding-bottom:0;\r\n\t}\r\n\t\r\n\t.bg-levels {\r\n\t\tbackground-color: transparent;\r\n\t}\r\n\r\n\t.dropdown-menu {\r\n\t\tmax-width: none;\r\n\t}\r\n\r\n\t.ps-md-45 {\r\n\t\tpadding-left: 2rem !important;\r\n\t}\r\n\r\n\t.table-row.single-table-row {\r\n\t\tpadding: .8rem 1rem .8rem calc(1.5rem + 5px);\r\n\t}\r\n\r\n\t.to-show {\r\n\t\tdisplay: none;\r\n\t}\r\n}\r\n\r\n@media (max-width: 991.98px) and (orientation: landscape) {\r\n\t.sign-view {\r\n\t\tmin-height: 100vw;\r\n\t}\r\n}\r\n\r\n@media (min-width: 992px) { \r\n\t.btn, \r\n\t.dropdown-menu-container, \r\n\t.swap-background-checkbox > input[type=checkbox].form-check-input:checked ~ label,\r\n\t.swap-background-checkbox > input[type=radio].form-check-input:checked ~ label,\r\n\t.form-control, \r\n\t.form-control-plaintext, \r\n\t.form-select, \r\n\t.input-group input, \r\n\t.input-group-text {\r\n\t\tline-height: 1.5em;\r\n\t} \r\n\r\n\t.form-box {\r\n\t\tbox-shadow: 0 5px 45px hsla(0, 0%, 0%, .25);\r\n\t\ttop: 0;\r\n\t\twidth: 50%;\r\n\t}\r\n\r\n\t.form-box form {\r\n\t\tpadding: 0 15%;\r\n\t}\r\n\r\n\t.ps-lg-45 {\r\n\t\tpadding-left: 2rem !important;\r\n\t}\r\n\r\n\t.sign-container > * {\r\n\t\theight: 500px;\r\n\t}\r\n\r\n\t.sign-container .row {\r\n\t\talign-items: center!important;\r\n\t}\r\n\r\n\t.sign-container .row div:first-of-type{\r\n\t\tborder-radius: .375rem 0 0 .375rem ;\r\n\t}\r\n\r\n\t.sign-container .row div:last-of-type{\r\n\t\tborder-radius: 0 .375rem .375rem 0;\r\n\t}\r\n\r\n\t.sign-container .row [class^=\"col-\"] {\r\n\t\theight: 420px;\r\n\t}\r\n\r\n\t.sign-view {\r\n\t\tdisplay: flex;\r\n\t\tjustify-content: center;\r\n\t\tmin-height: 100vh;\r\n\t}\r\n\r\n\t.sign-view.up-active .form-box {\r\n\t\tleft: 50%;\r\n\t\ttop: 0;\r\n\t}\r\n\r\n\t.sign-view .sign-box.signin, \r\n\t.sign-view .sign-box.signup, \r\n\t.sign-view.up-active .sign-box {\r\n\t\tmargin-top: 150px;\r\n\t}\r\n\r\n\t.table-row.single-table-row {\r\n\t\tpadding: 1rem 1rem 1rem calc(2rem + 5px);\r\n\t}\r\n\r\n\t.w-lg-100 {\r\n\t\twidth: 100% !important;\r\n\t}\r\n}\r\n\r\n@media (min-width: 1200px) { \r\n\t.w-xl-auto {\r\n\t\twidth: auto !important;\r\n\t}\r\n}\r\n\r\n\r\n/* ---------- Questa roba andrà spostata nel componente taskListPanel quando ci sarà */\r\n#taskListBox .status-2 {\r\n\tbackground-color: #4b4b4b;\r\n\topacity: .5;\r\n}\r\n\r\n#taskListBox .status-7 {\r\n\tbackground-color: #3b1f1f;\r\n\topacity: .5;\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
